<template>
  <v-app>
    <div v-if="loading" style="height: 100vh">
      <v-layout fill-height justify-center align-center>
        <v-flex class="text-xs-center">
          <v-progress-circular
            :key="theme.color"
            indeterminate
            :color="theme.color"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </div>
    <template v-else>
      <v-content class="mb-5">
        <merchant-detail
          v-model="pageProfile"
          id="merchant"
          :showSearch="false"
        >
          <!-- <div slot="header" class="text-xs-right">
            <v-spacer></v-spacer>
            <span class="mr-4">ยอดคงเหลือ</span>
            <span class="mr-4"
              ><v-icon small>mdi-bottle-soda-classic</v-icon>ขวดเล็ก {{ bottle.small }}</span
            >
            <span><v-icon>mdi-bottle-soda-classic</v-icon> ขวดใหญ่ {{ bottle.large }}</span>
          </div> -->
        </merchant-detail>
        <template v-if="page == 'products'">
          <v-layout wrap fill-height>
            <template v-if="filterProducts.length > 0">
              <template v-for="(product, pindex) in filterProducts">
                <v-flex
                  xs6
                  sm4
                  md3
                  lg2
                  xl2
                  class="pa-2"
                  v-if="product.type != 'none'"
                  :key="'product_' + filterProducts[pindex].id"
                  @selectProduct="onSelectProduct(filterProducts[pindex])"
                >
                  <nvbb-drink-product
                    v-model="filterProducts[pindex]"
                    :totalBottle="totalBottle"
                    :bottle="bottle"
                    @changeBottle="changeBottle"
                  ></nvbb-drink-product>
                </v-flex>
              </template>
            </template>
          </v-layout>

          <div style="height: 60px"></div>
          <v-bottom-nav
            fixed
            :value="showCheckoutButton"
            :color="theme.color"
            dark
            style="height: 68px"
          >
            <v-btn
              flat
              value="nearby"
              @click="onCheckout"
              :disabled="!showCheckoutButton"
            >
              <span>{{ $t('Checkout') }}</span>
              <v-badge color="red" v-show="showCheckoutButton">
                <template v-slot:badge>
                  <span>{{ grandTotalBottle }}</span>
                </template>
                <v-icon>mdi-cart-plus</v-icon>
              </v-badge>
            </v-btn>
          </v-bottom-nav>
          <!-- <v-tooltip top :value="!showTooltip" color="red">
            <template v-slot:activator="{ on }">
              
            </template>
            <span
              >เมื่อซื้อครบ
              <template v-if="shippingType == 'hub'">
                6
              </template>
              <template v-else-if="shippingType == 'scg'">
                15
              </template>
              <template v-else-if="shippingType == 'interexpress'">
                25
              </template>
              ขวดส่งฟรี</span
            >
          </v-tooltip> -->
        </template>
        <template v-else-if="page == 'checkout'">
          <v-container>
            <v-btn
              flat
              @click="
                page = 'products'
                goTo(0)
              "
            >
              <v-icon class="mr-2">mdi-arrow-left</v-icon> ย้อนกลับ
            </v-btn>
            <v-layout wrap>
              <v-flex xs12 md6 class="pa-2">
                <h3 class="title mb-3 mt-2">รายการสินค้า</h3>
                <v-card>
                  <template v-for="product in productlist">
                    <template v-if="product.bottle.small > 0">
                      <v-card-text :key="'cart_' + product.id + '_small'">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.photourl" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }} (ขวดเล็ก)
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.bottle.small }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider_small'"
                      ></v-divider>
                    </template>
                    <template v-if="product.bottle.large > 0">
                      <v-card-text :key="'cart_' + product.id + '_large'">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.photourl" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }} (ขวดใหญ่)
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.bottle.large }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider_large'"
                      ></v-divider>
                    </template>
                  </template>
                  <template v-if="other_products">
                    <template v-for="product in other_products">
                      <v-card-text :key="'cart_' + product.id">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.imgae_url" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }}
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.qty }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider'"
                      ></v-divider>
                    </template>
                  </template>

                  <!-- <v-card-text> -->
                  <!-- <template v-for="val in producttype">
                      <template v-if="bottle[val] && totalBottle[val]">
                        <v-layout
                          :key="val + '_small'"
                          class="my-2"
                          v-if="
                            bottle[val].smallbottles - totalBottle[val].small !=
                              bottle[val].smallbottles
                          "
                        >
                          <v-flex>
                            ยอด
                            <template v-if="val">{{ $t(val) }}</template>
                            ขวดเล็กคงเหลือ
                          </v-flex>
                          <v-flex class="text-xs-right">
                            {{ bottle[val].smallbottles }}
                            <v-icon small>mdi-arrow-right</v-icon>
                            {{ bottle[val].smallbottles - totalBottle[val].small }}
                          </v-flex>
                        </v-layout>

                        <v-layout
                          :key="val + '_large'"
                          class="my-2"
                          v-if="
                            bottle[val].bigbottles - totalBottle[val].large !=
                              bottle[val].bigbottles
                          "
                        >
                          <v-flex>
                            ยอด
                            <template v-if="val">{{ $t(val) }}</template>
                            ขวดใหญ่คงเหลือ
                          </v-flex>
                          <v-flex class="text-xs-right">
                            {{ bottle[val].bigbottles }}
                            <v-icon small>mdi-arrow-right</v-icon>
                            {{ bottle[val].bigbottles - totalBottle[val].large }}
                          </v-flex>
                        </v-layout>
                      </template>
                    </template> -->

                  <!-- <v-layout class="my-2"> -->
                  <!-- v-if="
                        shippingType != 'hub' &&
                          shippingQuota[shippingType] > 0 &&
                          ((shippingType == 'scg' && grandTotalBottle < 15) ||
                            (shippingType == 'interexpress' && grandTotalBottle < 25))
                      " -->
                  <!-- <v-flex>
                        รอบการจัดส่งคงเหลือ
                        <template v-if="shippingType == 'scg'">
                          (จัดส่งกทม.ปริมณฑล)
                        </template>
                        <template v-else-if="shippingType == 'interexpress'">
                          (จัดส่งเย็นต่างจังหวัด)
                        </template>
                        <template v-else-if="shippingType == 'hub'">
                          ({{ destination == "home" ? "Hub to home" : "รับเองที่ Hub" }})
                        </template>
                      </v-flex>
                      <v-flex class="text-xs-right">
                        {{ shippingQuota[shippingType] }}
                        <v-icon small>mdi-arrow-right</v-icon>
                        {{ shippingQuota[shippingType] - 1 }}
                      </v-flex> -->
                  <!-- </v-layout> -->
                  <!-- <v-layout class="my-2" v-else>
                      <v-flex> รอบการจัดส่งคงเหลือ 
                        <template v-if="shippingType == 'scg'">
                          (จัดส่งกทม.ปริมณฑล)
                        </template>
                        <template v-else-if="shippingType == 'interexpress'">
                          (จัดส่งเย็นต่างจังหวัด)
                        </template>
                        <template v-else-if="shippingType == 'hub'">
                          ({{ destination == "home" ? "Hub to home" : "รับเองที่ Hub" }})
                        </template>
                      </v-flex>
                      <v-flex class="text-xs-right"> ฟรี </v-flex>
                    </v-layout> -->
                  <!-- </v-card-text>
                  <v-divider></v-divider> -->
                  <v-card-text>
                    <v-layout
                      class="my-2 title"
                      :style="{ color: theme.color }"
                    >
                      <v-flex> ยอดจัดส่งรวม </v-flex>
                      <v-flex class="text-xs-right">
                        {{ grandTotalBottle }}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6 class="pa-2">
                <h3 class="title mb-3 mt-2">เลือกวิธีจัดส่ง</h3>
                <v-card>
                  <v-card-text>
                    <v-radio-group
                      @change="pickupdate = null"
                      name="shippingtype"
                      v-model="shippingType"
                      v-validate="'required'"
                      :error="errors.has('shippingtype') ? true : false"
                      :error-messages="
                        errors.has('shippingtype')
                          ? errors.first('shippingtype')
                          : ''
                      "
                    >
                      <v-radio
                        class="mb-3 radio-custom"
                        :class="{
                          active: shippingType === 'hub'
                        }"
                        color="primary"
                        value="hub"
                      >
                        <template v-slot:label>
                          <div class="radio-custom__content">
                            <div class="radio-custom__header">
                              <div class="radio-custom__title">HUB</div>
                              <div>ฝากแช่❄️ เข้ารับตามสะดวก</div>
                            </div>
                            <div class="radio-custom__body">
                              <div>
                                🕐 เวลา: เข้ารับสินค้าที่ร้านพันธมิตรใกล้บ้าน
                              </div>
                              <div>
                                🛍️ ส่งมอบ: สินค้าในถุงฟอยด์รักษาความเย็น
                              </div>
                              <div>🗓️ รอบส่ง: อังคาร พฤหัสบดี เสาร์</div>
                              <div>ค่าบริการ: เริ่มต้น 60.-</div>
                            </div>
                          </div>
                        </template>
                      </v-radio>
                      <v-radio
                        class="radio-custom mb-3"
                        :class="{
                          active: shippingType === 'drop'
                        }"
                        color="primary"
                        value="drop"
                      >
                        <template v-slot:label>
                          <div class="radio-custom__content">
                            <div class="radio-custom__header">
                              <div class="radio-custom__title">
                                HUB-DELIVERY
                              </div>
                              <div>❄️ จัดส่งจากร้านค้าพันธมิตร</div>
                            </div>
                            <div class="radio-custom__body">
                              <div>
                                🕐 เวลา: ระบุช่วงเวลารับได้ (เมื่อสินค้าถึง)
                              </div>
                              <div>
                                🛍️ ส่งมอบ: สินค้าในถุงฟอยด์รักษาความเย็น
                              </div>
                              <div>🗓️ รอบส่ง: อังคาร พฤหัสบดี เสาร์</div>
                              <div>ค่าบริการ: ตามพิกัด (ไม่เกิน 35 ขวด)</div>
                            </div>
                          </div>
                        </template>
                      </v-radio>
                      <!-- <v-radio class="mb-3" color="primary" value="hub+msg">
                        <template v-slot:label>
                          <div
                            style="
                              color: black;
                              flex-direction: column;
                              justify-content: start;
                              text-align: left;
                            "
                          >
                            <strong>HUB (DELIVERY)</strong>
                            <div>ฝากแช่❄️ รอเรียกแมส (+ 🛵📦ชำระปลายทาง)</div>
                          </div>
                        </template>
                      </v-radio> -->
                      <v-radio
                        class="mb-3 radio-custom"
                        :class="{
                          active: shippingType === 'express'
                        }"
                        color="primary"
                        value="express"
                      >
                        <template v-slot:label>
                          <div class="radio-custom__content">
                            <div class="radio-custom__header">
                              <div class="radio-custom__title">
                                EXPRESS 0-8 °c
                              </div>
                              <div>
                                🚛❄️ จัดส่งควบคุมความเย็น 0-8
                                องศาถึงบ้านทั่วประเทศ
                              </div>
                            </div>
                            <div class="radio-custom__body">
                              <div>🕐 เวลา: ขึ้นอยู่กับขนส่ง</div>
                              <div>🛍️ ส่งมอบ: ** ต้องมีผู้รับแช่เย็น **</div>
                              <div>
                                🗓️ กทม.และปริมณฑล รอบส่ง: จันทร์ - เสาร์
                              </div>
                              <div>🗓️ ตจว. รอบส่ง: อังคาร และ พฤหัสบดี</div>
                            </div>
                          </div>
                        </template>
                      </v-radio>

                      <v-radio
                        class="radio-custom mb-3"
                        :class="{
                          active: shippingType === 'admin_suggest'
                        }"
                        color="primary"
                        value="admin_suggest"
                      >
                        <template v-slot:label>
                          <div class="radio-custom__content">
                            <div class="radio-custom__header">
                              <div class="radio-custom__title">
                                ไม่แน่ใจ (ให้แอดมินแนะนำ)
                              </div>
                              <div>
                                ให้แอดมินช่วยเลือกวิธีการจัดส่งที่เหมาะสมให้ค่ะ
                              </div>
                            </div>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6 offset-md6 class="pa-2" v-if="shippingType">
                <h3 class="title mb-3 mt-2">ที่อยู่การจัดส่ง</h3>
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      v-if="shippingType !== 'drop'"
                      :color="theme.color"
                      v-model="useSameAddress"
                      :label="`ใช้ที่อยู่เดียวกับที่อยู่ซื้อโควต้า`"
                      @change="switchUserAddress"
                    ></v-checkbox>

                    <div
                      :class="{ 'has-error': errors.has('customerName') }"
                      class="mb-1"
                    >
                      <v-text-field
                        :label="$t('Name')"
                        :data-vv-as="$t('Name')"
                        outline
                        name="customerName"
                        v-validate="'required'"
                        v-model="customerName"
                        light
                        :color="theme.color"
                        :hide-details="!errors.has('customerName')"
                        class="mb-2"
                        :error="errors.has('customerName') ? true : false"
                        :error-messages="
                          errors.has('customerName')
                            ? errors.first('customerName')
                            : ''
                        "
                        @blur="changeInfo"
                      ></v-text-field>
                    </div>

                    <template v-if="['hub', 'hub+msg'].includes(shippingType)">
                      <div
                        :class="{ 'has-error': errors.has('hubLocation') }"
                        class="mb-1"
                      >
                        <v-select
                          @change="pickupdate = null"
                          v-model="hubLocation"
                          outline
                          label="สถานที่รับสินค้า"
                          key="บัญชี"
                          data-vv-as="สถานที่รับสินค้า"
                          v-validate="'required'"
                          :color="theme.color"
                          :items="hubLocationOptions"
                          name="hubLocation"
                          :hide-details="!errors.has('hubLocation')"
                          class="mb-2"
                          :error="errors.has('hubLocation') ? true : false"
                          :error-messages="
                            errors.has('hubLocation')
                              ? errors.first('hubLocation')
                              : ''
                          "
                        ></v-select>
                      </div>
                      <div v-if="currentHub" class="pt-2 pb-3">
                        <v-alert :value="true" color="info" outline>
                          <div
                            class="description"
                            style="word-break: break-word"
                          >
                            <nl2br
                              v-if="currentHub.desc"
                              tag="span"
                              :text="currentHub.desc"
                            ></nl2br>
                            <br />
                            <a
                              v-if="currentHub.link"
                              :href="currentHub.link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >{{ currentHub.link }}</a
                            >
                          </div>
                        </v-alert>
                      </div>
                    </template>
                    <!-- <template v-else-if="shippingType == 'drop'">
                      <div v-if="currentDroppoint" class="pt-2 pb-3">
                        <v-alert :value="true" color="info" outline>
                          <div
                            class="description"
                            style="word-break: break-word"
                          >
                            <nl2br
                              v-if="currentDroppoint.desc"
                              tag="span"
                              :text="currentDroppoint.desc"
                            ></nl2br>
                            <br />
                            <a
                              v-if="currentDroppoint.link"
                              :href="currentDroppoint.link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >{{ currentDroppoint.link }}</a
                            >
                          </div>
                        </v-alert>
                      </div>
                    </template> -->

                    <template>
                      <div v-if="shippingType == 'drop'" class="mb-1">
                        {{ $t('Shipping Address') }}
                      </div>
                      <div
                        v-if="
                          shippingType == 'drop' &&
                          ['102459484852582', '102438735480946'].includes(
                            pageProfile.pageid
                          )
                        "
                        class="mb-2"
                        style="
                          border: 2px solid rgba(0, 0, 0, 0.54);
                          background: transparent !important;
                          border-radius: 4px;
                          padding: 0 12px;
                        "
                      >
                        <div v-if="loadingLalamove" class="my-2 text-xs-center">
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                        </div>

                        <template v-else>
                          <template v-if="totalPrice">
                            <v-layout wrap row>
                              <v-flex sm12>
                                <div
                                  class="mt-2"
                                  style="
                                    color: rgba(0, 0, 0, 0.54);
                                    font-size: 12px;
                                  "
                                >
                                  โซนจัดส่ง
                                  <v-btn
                                    class="ml-2"
                                    small
                                    outline
                                    color="primary"
                                    dark
                                    @click.stop="editAddressDroppoint = true"
                                  >
                                    เปลี่ยนโซนจัดส่ง
                                  </v-btn>
                                </div>
                                <p v-if="hubLocationDroppoint">
                                  {{ hubLocationDroppoint.text }} <br />{{
                                    hubLocationDroppoint.desc
                                  }}
                                  {{
                                    hubLocationDroppoint.timePeriod !== ''
                                      ? 'เวลา' + hubLocationDroppoint.timePeriod
                                      : ''
                                  }}
                                </p>
                              </v-flex>
                            </v-layout>
                            <div
                              style="
                                color: rgba(0, 0, 0, 0.54);
                                font-size: 12px;
                              "
                            >
                              ที่อยู่ผู้รับ
                              <v-btn
                                class="ml-2"
                                small
                                outline
                                color="primary"
                                dark
                                @click.stop="editAddress = true"
                              >
                                แก้ไขที่อยู่จัดส่ง
                              </v-btn>
                            </div>
                            <p>{{ shippingAddress }}</p>
                            <div
                              class="mt-2 mb-2"
                              style="
                                border-radius: 5px;
                                padding: 5px;
                                color: white;
                                background: green;
                              "
                            >
                              ค่าส่ง Delivery
                              {{ totalPrice | decimalFormat }} บาท
                            </div>
                            <div class="mb-2">
                              * ค่าส่งอัพเดทเรียลไทม์จาก Lalamove
                            </div>
                          </template>
                          <template v-else>
                            <div class="text-xs-center">
                              <v-btn
                                color="primary"
                                style="width: 100%; margin-left: 0px"
                                dark
                                @click.stop="editAddress = true"
                              >
                                เพิ่มที่อยู่จัดส่ง
                              </v-btn>
                            </div>
                          </template>
                        </template>
                      </div>
                      <template v-else>
                        <v-textarea
                          outline
                          :label="$t('Shipping Address')"
                          name="shippingAddress"
                          rows="5"
                          :data-vv-as="$t('Shipping Address')"
                          style="resize: none; width: 100%"
                          v-model="shippingAddress"
                          light
                          :color="theme.color"
                          :hide-details="!errors.has('shippingAddress')"
                          class="mb-2"
                          :placeholder="
                            $t('Ex. Address No., Village, Alley, and Road')
                          "
                          :error="errors.has('shippingAddress') ? true : false"
                          :error-messages="
                            errors.has('shippingAddress')
                              ? errors.first('shippingAddress')
                              : ''
                          "
                          @blur="changeInfo"
                        ></v-textarea>
                        <v-text-field
                          :label="$t('zipcode')"
                          :data-vv-as="$t('zipcode')"
                          outline
                          type="number"
                          name="zipcode"
                          light
                          :color="theme.color"
                          v-validate="{
                            required: true,
                            regex: /^\d{5}$/
                          }"
                          v-model="postcode"
                          :hide-details="!errors.has('zipcode')"
                          class="mb-2 input-zipcode"
                          :error="errors.has('zipcode') ? true : false"
                          :error-messages="
                            errors.has('zipcode') ? errors.first('zipcode') : ''
                          "
                          @wheel="onWheelZipcode"
                          ref="inputZipcode"
                        ></v-text-field>
                      </template>

                      <v-dialog
                        persistent
                        v-model="editAddress"
                        max-width="600"
                      >
                        <v-card>
                          <v-card-text>
                            <v-layout class="mb-2" wrap row>
                              <v-flex> <h3>แก้ไขที่อยู่จัดส่ง</h3> </v-flex>
                              <v-flex class="text-xs-right">
                                <!-- <v-icon style="cursor: pointer" @click="editAddress = false">
                                  close
                                </v-icon> -->
                              </v-flex>
                            </v-layout>
                            <gmap-address
                              class="mb-2"
                              v-if="
                                showmap &&
                                editAddress &&
                                shippingType == 'drop' &&
                                ['102459484852582', '102438735480946'].includes(
                                  pageProfile.pageid
                                )
                              "
                              :placesinfo.sync="placesinfolabel"
                              :shippingType="chooseShippingType"
                              v-validate="{ required: true }"
                              name="ปักหมุดที่อยู่"
                              v-model="gmapvalue"
                              v-on:input="gmapLocation(false)"
                              :lastordercoords="gmapvalue"
                              :error="errors.has('ปักหมุดที่อยู่')"
                              :shoplocation="shoplocation"
                              :radius="0"
                              :infoloading="loadingMapInfo"
                              @onMapLoading="onMapLoading"
                              @onMapReady="onMapReady"
                              :scrollable="true"
                              :nvbb="true"
                            ></gmap-address>
                            <!-- <div class="mb-2">
                              ** ขยับหมุดได้ และสามารถพิมพ์แก้ไขที่อยู่ด้านล่างได้ (
                              กรณีที่ข้อมูลจาก Google Map ไม่ตรงกับที่อยู่ของท่าน )
                            </div> -->
                            <div class="px-2 py-4 my-2 primary white--text">
                              <v-layout
                                :value="true"
                                prominent
                                text
                                color="primary"
                              >
                                <v-flex class="text-xs-center pa-2">
                                  <v-icon style="font-size: 35px">
                                    mdi-map-marker
                                  </v-icon>
                                </v-flex>

                                <v-flex class="pa-2">
                                  <div v-if="shippingAddressSet">
                                    <strong>{{
                                      `(${shippingAddressSet}) `
                                    }}</strong>
                                  </div>
                                  <div v-html="placesinfolabel"></div>
                                </v-flex>
                              </v-layout>
                            </div>
                            <v-textarea
                              outline
                              :label="$t('additional_note')"
                              name="shippingAddressSet"
                              rows="5"
                              :data-vv-as="$t('additional_note')"
                              style="resize: none; width: 100%"
                              v-model="shippingAddressSet"
                              light
                              :color="theme.color"
                              :hide-details="!errors.has('shippingAddressSet')"
                              class="mb-2"
                              :placeholder="
                                $t('Ex. Address No., Village, Alley, and Road')
                              "
                            ></v-textarea>
                            <v-btn
                              class="pl-0 ml-0"
                              style="width: 100%"
                              outline
                              color="primary"
                              @click="
                                editAddress = false
                                gmapLocation(true)
                              "
                            >
                              ยืนยันการแก้ไข
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        persistent
                        v-model="editAddressDroppoint"
                        max-width="600"
                      >
                        <v-card>
                          <v-card-text>
                            <v-layout class="mb-2" wrap row>
                              <v-flex> <h3>เปลี่ยนโซนจัดส่ง</h3> </v-flex>
                              <v-flex class="text-xs-right">
                                <v-icon
                                  style="cursor: pointer"
                                  @click="editAddressDroppoint = false"
                                >
                                  close
                                </v-icon>
                              </v-flex>
                            </v-layout>
                            <v-autocomplete
                              outline
                              v-model="droppointLocationOptions_1Select"
                              :items="droppointLocationOptions"
                              item-value="text"
                              item-text="text"
                              small
                              filled
                              :label="$t('เปลี่ยนโซนจัดส่ง')"
                            ></v-autocomplete>
                            <v-btn
                              class="pl-0 ml-0"
                              style="width: 100%"
                              outline
                              color="primary"
                              @click="
                                if (droppointLocationOptions_1Select) {
                                  changeDroppoint()
                                }
                                editAddressDroppoint = false
                              "
                            >
                              ยืนยันการแก้ไข
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </template>
                    <div
                      v-if="shippingType != 'admin_suggest'"
                      :class="{ 'has-error': errors.has('customerPhone') }"
                      class="mb-1"
                    >
                      <v-text-field
                        :label="$t('Tel.')"
                        :data-vv-as="$t('Tel.')"
                        outline
                        type="number"
                        name="customerPhone"
                        light
                        :color="theme.color"
                        v-validate="{
                          required: true,
                          regex:
                            /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                        }"
                        v-model="customerPhone"
                        :hide-details="!errors.has('customerPhone')"
                        class="mb-2"
                        :error="errors.has('customerPhone') ? true : false"
                        :error-messages="
                          errors.has('customerPhone')
                            ? errors.first('customerPhone')
                            : ''
                        "
                        @blur="changeInfo"
                      ></v-text-field>

                      <v-dialog
                        ref="dialog"
                        v-model="showDatePicker"
                        :return-value.sync="pickupdate"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="pickupdate"
                            label="วันที่รับสินค้า"
                            :data-vv-as="'วันที่รับสินค้า'"
                            prepend-inner-icon="event"
                            readonly
                            name="pickupdate"
                            v-validate="'required'"
                            :error="errors.has('pickupdate') ? true : false"
                            :hide-details="!errors.has('pickupdate')"
                            class="mb-2"
                            :error-messages="
                              errors.has('pickupdate')
                                ? errors.first('pickupdate')
                                : ''
                            "
                            outline
                            :color="theme.color"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickupdate"
                          scrollable
                          :color="theme.color"
                          :min="mindate"
                          :allowed-dates="allowedDates"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            flat
                            :color="theme.color"
                            @click="showDatePicker = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            :color="theme.color"
                            @click="$refs.dialog.save(pickupdate)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </div>
                    <div
                      :class="{ 'has-error': errors.has('remark') }"
                      class="mb-1"
                    >
                      <v-textarea
                        :label="$t('หมายเหตุ')"
                        :data-vv-as="$t('หมายเหตุ')"
                        outline
                        name="remark"
                        light
                        :color="theme.color"
                        v-model="remark"
                        :hide-details="!errors.has('remark')"
                        class="mb-2"
                        :error="errors.has('remark') ? true : false"
                        :error-messages="
                          errors.has('remark') ? errors.first('remark') : ''
                        "
                      ></v-textarea>
                    </div>

                    <div
                      :class="{ 'has-error': errors.has('remarkToDriver') }"
                      class="mb-1"
                      v-if="
                        shippingType == 'drop' &&
                        ['102459484852582', '102438735480946'].includes(
                          pageProfile.pageid
                        )
                      "
                    >
                      <!-- <v-textarea
                        :label="$t('ข้อความถึงคนขับ')"
                        :data-vv-as="$t('ข้อความถึงคนขับ')"
                        outline
                        name="remarkToDriver"
                        light
                        :color="theme.color"
                        v-model="remarkToDriver"
                        :hide-details="!errors.has('remarkToDriver')"
                        class="mb-2"
                        :error="errors.has('remarkToDriver') ? true : false"
                        :error-messages="
                          errors.has('remarkToDriver') ? errors.first('remarkToDriver') : ''
                        "
                      ></v-textarea> -->
                    </div>

                    <v-alert
                      v-if="shippingType == 'drop' && grandTotalBottle > 35"
                      class="my-3"
                      :value="true"
                      color="red"
                      outline
                    >
                      <h2 class="text-xs-center">
                        ไม่สามารถจัดส่งเกิน 35 ขวดได้
                      </h2>
                    </v-alert>

                    <v-alert
                      class="my-3"
                      :value="true"
                      color="primary"
                      outline
                      v-else-if="
                        shippingType == 'drop' &&
                        ['102459484852582', '102438735480946'].includes(
                          pageProfile.pageid
                        )
                      "
                    >
                      <v-layout>
                        <v-flex>
                          <h2>ค่าจัดส่ง</h2>
                        </v-flex>
                        <v-flex class="text-xs-right">
                          <v-progress-circular
                            v-if="loadingLalamove"
                            indeterminate
                            color="primary"
                          ></v-progress-circular>
                          <h2 v-else>{{ totalPrice | decimalFormat }}</h2>
                        </v-flex>
                      </v-layout>
                    </v-alert>
                    <v-alert
                      v-if="
                        calculateShippingPrice &&
                        calculateShippingPrice != 'not_found_postcode'
                      "
                      class="my-3"
                      :value="true"
                      color="primary"
                      outline
                    >
                      <v-layout>
                        <v-flex>
                          <h2>
                            <template v-if="shippingType == 'express'">
                              ค่าจัดส่ง EXPRESS 0-8 °c
                            </template>
                            <template
                              v-else-if="
                                ['hub', 'hub+msg'].includes(shippingType)
                              "
                            >
                              ค่าบริการฝากแช่สินค้า
                            </template>
                          </h2>
                        </v-flex>
                        <v-flex class="text-xs-right">
                          <h2>{{ calculateShippingPrice | decimalFormat }}</h2>
                        </v-flex>
                      </v-layout>
                    </v-alert>
                    <v-alert
                      v-if="calculateShippingPrice === false"
                      class="my-3"
                      :value="true"
                      color="red"
                      outline
                    >
                      <h2 class="text-xs-center">
                        {{
                          locationCode === 'BKK' ||
                          locationCode === 'MET' ||
                          shippingType === 'hub'
                            ? 'ไม่สามารถจัดส่งเกิน 45 ขวดได้'
                            : 'ไม่สามารถจัดส่งเกิน 35 ขวดได้'
                        }}
                      </h2>
                    </v-alert>
                    <v-alert
                      v-else-if="
                        calculateShippingPrice === 'not_found_postcode'
                      "
                      class="my-3"
                      :value="true"
                      color="red"
                      outline
                    >
                      <h2 class="text-xs-center">ที่อยู่จัดส่งไม่ครบถ้วน</h2>
                    </v-alert>

                    <div class="my-2 text-xs-center">
                      หากมีรายการขัดข้อง
                      กรุณาแคปหน้าจอแจ้งแอดมินเพื่อดำเนินรายการให้ค่ะ
                    </div>

                    <v-btn
                      :loading="
                        shippingType == 'drop' &&
                        ['102459484852582', '102438735480946'].includes(
                          pageProfile.pageid
                        )
                          ? loadingLalamove
                          : false
                      "
                      style="color: #fff"
                      :color="theme.color"
                      block
                      @click="onProceedShipping"
                      :disabled="
                        (shippingType === 'drop' &&
                          totalPrice === null &&
                          ['102459484852582', '102438735480946'].includes(
                            pageProfile.pageid
                          )) ||
                        calculateShippingPrice === false ||
                        calculateShippingPrice === 'not_found_postcode' ||
                        (shippingType == 'drop' && grandTotalBottle > 35)
                      "
                      >ยืนยันการส่งสินค้า</v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from 'axios'
import moment from 'moment'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import Nl2br from 'vue-nl2br'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import vZoom from 'vue-zoom'
import NvbbDrinkProduct from './NvbbDrinkProduct'
import { getBangkokLocation, calculateShippingPrice } from '@/assets/js/Nvbb.js'
import * as Sentry from '@sentry/vue'
import GmapAddress from '@/components/ecommerce/GmapAddress.vue'
import Nvbb from '@/custom/nvbb'

export default {
  components: {
    MerchantDetail,
    Nl2br,
    vZoom,
    NvbbDrinkProduct,
    GmapAddress
  },
  computed: {
    droppointLocationOptions() {
      // if (
      //   ['102459484852582', '102438735480946'].includes(this.pageProfile.pageid)
      // ) {
      //   return this.droppointLocationOptions_1
      // } else {
      //   return this.droppointLocationOptions_2
      // }
      return this.commonDroppoint
    },
    hubLocationOptions() {
      return this.commonDroppoint.map((item) => {
        return {
          text: item.text,
          value: item.value,
          desc: item.addressName,
          link: item.link
        }
      })
    },
    commonDroppoint() {
      return [
        {
          text: 'โซน พระราม 2  - พันท้ายนรสิงห์',
          desc: '📍หมู่บ้านเดอะแกรนด์ พระราม 2📍',
          value: 'หมู่บ้านเดอะแกรนด์ พระราม 2',
          addressName:
            'หมู่บ้านเดอะแกรนด์ พระราม 2 พันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร สมุทรสาคร 74000',
          location: [
            {
              lat_long: '13.593292, 100.40551465678783',
              id: 'drop1'
            }
          ],
          link: 'https://goo.gl/maps/5NhoXpgfozd7nnHS6',
          shopCharg: 60,
          filterName: 'drop1',
          timePeriod: '9:30 - 17:00'
        },
        {
          text: 'โซนพระราม 4 - สุขุมวิท 26',
          desc: '📍Bolada Clinic📍',
          value: 'Bolada Clinic',
          addressName:
            'Bolada Clinic อยู่ใน Bambini Villa Community Mall ซอย อรรถกวี 1 แขวงคลองตัน เขตคลองเตย กรุงเทพมหานคร 10110',
          location: [
            {
              lat_long: '13.7194353, 100.5705016',
              id: 'drop2'
            }
          ],
          link: 'https://maps.app.goo.gl/MuxMFezEVGe9qo3D8?g_st=ic',
          shopCharg: 60,
          filterName: 'drop2',
          timePeriod: '14:00 - 20:00'
        },
        {
          text: 'โซน จตุจักร - ลาดพร้าว - พญาไท - ห้วยขวาง',
          desc: '📍อินทามระ📍',
          value: 'อินทามระ',
          addressName:
            // 'Warin House Cafe, Brunch & Bar 24 ซอย ยาสูบ 2 แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900',
            '17 ซอย อินทามระ 30 แขวงรัชดาภิเษก เขตดินแดง กรุงเทพมหานคร 10400',
          location: [
            {
              lat_long: '13.7867756, 100.5653213',
              id: 'drop3'
            }
          ],
          link: 'https://maps.app.goo.gl/swwn7vFBYaRkmSXM6?g_st=il',
          shopCharg: 60,
          filterName: 'drop3',
          // timePeriod: '8:00 - 21:00'
          timePeriod: '9:00 - 20:00'
        },
        {
          text: 'โซน ราชพฤกษ์ - วงเวียนพระราม 5 นนทบุรี',
          desc: '📍Everyday Healthy📍',
          value: 'Everyday Healthy',
          addressName:
            'Everyday Healthy ราชพฤกษ์ วงเวียนพระราม 5 117/7 โครงการAt Rama5 ถ. นครอินทร์ อำเภอบางกรวย นนทบุรี 11130',
          location: [
            {
              lat_long: '13.8246005, 100.4461831',
              id: 'drop4'
            }
          ],
          link: 'https://maps.app.goo.gl/2WH4uc4x48JLCcr37',
          shopCharg: 60,
          filterName: 'drop4',
          timePeriod: '9:00 - 19:00'
        }
      ]
    },
    showCheckoutButton() {
      var totalbottle = this.grandTotalBottle
      return totalbottle >= 1
      // eslint-disable-next-line no-unreachable
      if (this.shippingType == 'hub') {
        // eslint-disable-next-line vue/no-async-in-computed-properties
        // setTimeout(() => {
        //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.showTooltip = totalbottle >= 6;
        // }, 1000);
        // return totalbottle >= 6;
      } else if (this.shippingType == 'scg') {
        // if (this.shippingQuota["scg"] == 0) {
        //   // eslint-disable-next-line vue/no-async-in-computed-properties
        //   setTimeout(() => {
        //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //     this.showTooltip = totalbottle >= 15;
        //   }, 1000);
        //   return totalbottle >= 15;
        // } else {
        //   return totalbottle > 0;
        // }
      } else if (this.shippingType == 'interexpress') {
        // if (this.shippingQuota["interexpress"] == 0) {
        //   // eslint-disable-next-line vue/no-async-in-computed-properties
        //   setTimeout(() => {
        //     // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //     this.showTooltip = totalbottle >= 25;
        //   }, 1000);
        //   return totalbottle >= 25;
        // } else {
        //   return totalbottle > 0;
        // }
      }
    },
    currentHub() {
      if (this.hubLocation) {
        return this.hubLocationOptions.find((el) => {
          return el.value == this.hubLocation
        })
      } else {
        return ''
      }
    },
    currentDroppoint() {
      if (this.hubLocationDroppoint && this.hubLocationDroppoint.value) {
        return this.droppointLocationOptions.find((el) => {
          return el.value == this.hubLocationDroppoint.value
        })
      } else {
        return ''
      }
    },
    ...mapGetters({
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    filterProducts() {
      return this.productlist.filter((el) => {
        return [62, 464].includes(el.categoryid)
      })
    },
    // totalBottle() {
    //   let total = this.getTotalBottle()
    //   let totalBottle = this.producttype
    //     .map((el) => {
    //       if (el == 'phytoshot') {
    //         return (total[el].large + total[el].small) / 2
    //       } else if (total[el] !== undefined) {
    //         return total[el].large + total[el].small
    //       } else return null
    //     })
    //     .filter((el) => {
    //       return el != null
    //     })
    //     .reduce((prev, curr) => {
    //       return prev + curr
    //     }, 0)

    //   return totalBottle
    // },
    // grandTotalBottle() {
    //   var total = this.getTotalBottle();
    //   return this.producttype
    //     .map((el) => {

    //       if (total[el] !== undefined) {
    //         return total[el].large + total[el].small;
    //       } else return null;
    //     })
    //     .filter((el) => {

    //       return el != null;
    //     })
    //     .reduce((prev, curr) => {

    //       return prev + curr;
    //     }, 0);
    // },
    calculateShippingPrice() {
      //
      let rate = 0
      let total = this.getTotalBottle()
      let totalBottle = this.producttype
        .map((el) => {
          if (el == 'phytoshot') {
            return (total[el].large + total[el].small) / 2
          } else if (total[el] !== undefined) {
            return total[el].large + total[el].small
          } else return null
        })
        .filter((el) => {
          return el != null
        })
        .reduce((prev, curr) => {
          return prev + curr
        }, 0)
      try {
        rate = calculateShippingPrice({
          type: this.shippingType,
          address: this.shippingAddress,
          zipcode: this.postcode,
          total: totalBottle
        })
        if (rate != false) return Math.ceil(rate)
        return rate
      } catch (error) {
        return false
      }
    },
    locationCode() {
      let postcode = this.postcode
      if (!postcode) {
        try {
          postcode = this.shippingAddress.match(/[1-9]{1}[0-9]{4}/)
          if (postcode.length > 0) {
            postcode = postcode[0].trim()
          } else {
            throw new Error('Many postcode')
          }
        } catch (error) {
          postcode = false
        }
      }

      if (!postcode) {
        return false
      }
      let location = getBangkokLocation(postcode, this.shippingAddress)
      return location
    },
    mindate() {
      const now = moment()

      const noon = moment().hour(12).minute(0).second(0)
      const evening = moment().hour(18).minute(0).second(0)

      let daysToAdd = 0

      if (now.isBefore(noon)) {
        daysToAdd = 1
      } else if (now.isBefore(evening)) {
        daysToAdd = 2
      } else {
        daysToAdd = 3
      }

      return moment().add(daysToAdd, 'days').format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      //gmap
      // shippingcostdistance: {
      //   shoplocation: [
      //     {
      //       name: "ooooo",
      //       id: "2021-08-30T05:38:54.613Z",
      //       lat_long: "13.820575104063616, 100.67562740758471",
      //     },
      //   ],
      // },
      hubLocationDroppoint: null,
      shippingAddressSet: '',
      totalPrice: null,
      editAddress: false,
      editAddressDroppoint: false,
      showmap: false,
      loadingLalamove: false,
      gmapvalue: {},
      shoplocation: [],
      externalScript: null,
      // googleapikey: 'AIzaSyA4vEtOImJL00yQs_tFrEhKKWFoRO959xc',
      googleapikey: 'AIzaSyAm0yu4hpk38jkrLYDlw_rM3P_SkIV6MjU',
      placesinfolabel: null,
      lastordercoords: null,
      branchlocation: [],
      loadingMap: true,
      deliveryOption: [],
      chooseShippingType: 'lalamove',
      lalamove: {
        result: null,
        fee: 0,
        shop_fee: 0
      },
      loadingMapInfo: true,
      shippingAddress2: {
        address: '',
        zipcode: '',
        province: '',
        district: '',
        sub_district: ''
      },

      totalBottle: [],
      grandTotalBottle: 0,
      producttype: ['phytosmooz', 'phytomylk', 'phytoshot', 'none', 'other'],
      showDatePicker: false,
      pickupdate: null,
      // mindate: moment().add('2', 'days').format('YYYY-MM-DD'),
      customerName: '',
      shippingAddress: '',
      postcode: '',
      customerPhone: '',
      page: 'products',
      loading: true,
      cart: [],
      bottle: {
        small: 0,
        large: 0
      },
      shippingQuota: {
        scg: 0,
        interexpress: 0,
        hub: 0
      },
      userid: null,
      categories: [],
      products: {},
      allproducts: [],
      productlist: [],
      hasSaleCategory: false,
      shippingType: null,
      showTooltip: true,
      other_products: null,
      shippingTypeOption: [
        { name: 'SCG Express', value: 'scg' },
        { name: 'Inter Express', value: 'interexpress' },
        { name: 'HUB', value: 'hub' }
      ],
      hubLocation: null,
      timePeriod: null,
      timePeriodOptions: ['10:00-14:00', '12:00-16:00', '14:00-17:00'],
      // hubLocationOptions: [
      //   {
      //     text: 'หมู่บ้านเดอะแกรนด์ 98/10',
      //     value: 'หมู่บ้านเดอะแกรนด์',
      //     desc: `⭐ หมู่บ้านเดอะแกรนด์ พระราม2\n98/10 (ซอย 6 โซนเลค)\n🕓 ช่วง 9:00-17:00\n(061-8358057, 064-424659)`,
      //     link: 'https://maps.app.goo.gl/LbvZKEoz49gv6XRj8?g_st=il'
      //   },
      //   {
      //     text: 'ร้าน BAANTOON Cafe',
      //     value: 'บางบอน - บางแค',
      //     desc: `📍ใกล้กับ รพ.สมุทรสาคร📍\nร้าน BAANTOON Cafe\nCall : 034-423433`,
      //     // link: 'https://goo.gl/maps/3t16hNmM86MA5yq56'
      //     link: 'https://maps.app.goo.gl/2et1qwWunJVtyFRD8',
      //     timePeriod: '08:30 - 18:30'
      //   },
      //   {
      //     text: 'Bolada Clinic',
      //     value: 'Bolada Clinic',
      //     desc: '⭐ Bolada Clinic\nอยู่ใน Bambini Villa Community Mall\n🕓 ช่วง 14:00 - 20:00 (064 935 4255)',
      //     link: 'https://maps.app.goo.gl/MuxMFezEVGe9qo3D8?g_st=ic'
      //   }
      // ],
      droppointLocationOptions_1Select: null,
      droppointLocationOptions_1: [
        // {
        //   text: 'บางบอน-เอกชัย (PTT-BB3)',
        //   desc: `📍บางบอน-เอกชัย (PTT-BB3)📍`,
        //   value: 'บางบอน-เอกชัย (PTT-BB3)',
        //   addressName:
        //     '99, ปั๊มน้ำมัน ปตท. สาขา บางบอน 99 ถ. เอกชัย แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150',
        //   location: [
        //     {
        //       lat_long: '13.656371920694491, 100.39405052096835',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop1',
        //   timePeriod: '10:00 - 15:00'
        // },
        // {
        //   text: 'พุทธมณฑล-สนามหลวง 2 (LT)',
        //   desc: `📍พุทธมณฑล-สนามหลวง 2 (LT)📍`,
        //   value: 'พุทธมณฑล-สนามหลวง 2 (LT)',
        //   addressName:
        //     'เทสโก้ โลตัส สนามหลวง 2 76/4 ถนนทวีวัฒนา แขวงทวีวัฒนา เขตทวีวัฒนา, กรุงเทพมหานคร 10170',
        //   location: [
        //     {
        //       lat_long: '13.747239687663944, 100.35444366793094',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 20,
        //   filterName: 'drop2',
        //   timePeriod: '10:00 - 15:00'
        // },
        // {
        //   text: 'กาญจนาภิเษก (ES)',
        //   desc: `📍กาญจนาภิเษก (ES)📍`,
        //   value: 'กาญจนาภิเษก (ES)',
        //   addressName:
        //     '136, Esso Gas Station 4 ถ. กาญจนาภิเษก แขวง บางระมาด เขตตลิ่งชัน กรุงเทพมหานคร 10170',
        //   location: [
        //     {
        //       lat_long: '13.776126053780834, 100.40910746731954',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop3',
        //   timePeriod: '10:00 - 15:00'
        // },
        {
          text: 'กาญจนาภิเษก (PT)',
          desc: `📍กาญจนาภิเษก (PT)📍`,
          value: 'กาญจนาภิเษก (PT)',
          addressName:
            'ปั๊มน้ำมันพีที บางบอน3 (กาแฟพันธุ์ไทย, Max Mart) 95/1 ถ. กาญจนาภิเษก แขวง บางบอน เขตบางบอน กรุงเทพมหานคร 10150',
          location: [
            {
              lat_long: '13.670219396886246, 100.40551465678783',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop4',
          timePeriod: '10:00 - 15:00'
        },
        // {
        //   text: 'กัลปพฤกษ์ (JF)',
        //   desc: `📍กัลปพฤกษ์ (JF)📍`,
        //   value: 'กัลปพฤกษ์ (JF)',
        //   addressName:
        //     'ปตท.จิ๊ฟฟี่ ถนนกัลปพฤกษ์ ขาออก 16/3 ถนน กัลปพฤกษ์ แขวง บางขุนเทียน เขตจอมทอง กรุงเทพมหานคร 10150',
        //   location: [
        //     {
        //       lat_long: '13.703614387449818, 100.44622539737809',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop5',
        //   timePeriod: '10:00 - 15:00'
        // },
        {
          text: 'กัลปพฤกษ์ (HP)',
          desc: `📍กัลปพฤกษ์ (HP)📍`,
          value: 'กัลปพฤกษ์ (HP)',
          addressName:
            'โฮมโปร กัลปพฤกษ์ 604 ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160',
          location: [
            {
              lat_long: '13.695236978106088, 100.4361380758398',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop6',
          timePeriod: '10:00 - 15:00'
        },
        // {
        //   text: 'กัลปพฤกษ์ (PTT-MT)',
        //   desc: `📍กัลปพฤกษ์ (PTT-MT)📍`,
        //   value: 'กัลปพฤกษ์ (PTT-MT)',
        //   addressName:
        //     'ปตท. - จิฟฟี่ กรุงเทพ - สาทร ตากสิน 1 17 ถนน กัลปพฤกษ์ แขวง บางหว้า เขตภาษีเจริญ กรุงเทพมหานคร 10160',
        //   location: [
        //     {
        //       lat_long: '13.707986073281086, 100.45023882793562',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop7',
        //   timePeriod: '10:00 - 15:00'
        // },
        // {
        //   text: 'พระราม 2 (IND)',
        //   desc: `📍พระราม 2 (IND)📍`,
        //   value: 'พระราม 2 (IND)',
        //   addressName:
        //     'อินเด็กซ์ ลิฟวิ่งมอลล์ สาขาพระราม 2 (Index Living Mall) 120 ถ. พระรามที่ 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150',
        //   location: [
        //     {
        //       lat_long: '13.66599004120337, 100.44361782569385',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop8',
        //   timePeriod: '10:00 - 15:00'
        // },
        // {
        //   text: 'พระราม 2 (ธอส)',
        //   desc: `📍พระราม 2 (ธอส)📍`,
        //   value: 'พระราม 2 (ธอส)',
        //   addressName:
        //     'ธอส พระราม2 73 พระราม 2 ซอย 30 แขวง บางมด เขตจอมทอง กรุงเทพมหานคร 10150',
        //   location: [
        //     {
        //       lat_long: '13.676941527721759, 100.4618235138312',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop9',
        //   timePeriod: '10:00 - 15:00'
        // },
        {
          text: 'สาทรเหนือ (CT)',
          desc: `📍สาทรเหนือ (CT)📍`,
          value: 'สาทรเหนือ (CT)',
          addressName:
            'ปั๊มคาลเท็กซ์ สาทรเหนือ ถ. สาทรเหนือ แขวง สีลม เขตบางรัก กรุงเทพมหานคร 10500',
          location: [
            {
              lat_long: '13.725104736149751, 100.54014915699695',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop10',
          timePeriod: '10:00 - 15:00'
        },
        // {
        //   text: 'พระราม 4 (BC-XT)',
        //   desc: '📍พระราม 4 (BC-XT)📍',
        //   value: 'พระราม 4 (BC-XT)',
        //   addressName:
        //     'บิ๊กซี พระราม 4 2929 ถนนพระรามที่ ๔ แขวง คลองตัน เขตคลองเตย กรุงเทพมหานคร 10110',
        //   location: [
        //     {
        //       lat_long: '13.718875251422839, 100.5690463825553',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop11',
        //   timePeriod: '12:00 - 16:00'
        // },
        {
          text: 'พระโขนง-สุขุมวิท 99 (บจ)',
          desc: '📍พระโขนง-สุขุมวิท 99 (บจ)📍',
          value: 'พระโขนง-สุขุมวิท 99 (บจ)',
          addressName:
            'ปั๊มน้ำมันบางจาก - สุขุมวิท 99 2999/1 ถ. สุขุมวิท แขวง บางจาก เขตพระโขนง กรุงเทพมหานคร 10260',
          location: [
            {
              lat_long: '13.69271004933028, 100.60770128539107',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop12',
          timePeriod: '12:00 - 16:00'
        },
        {
          text: 'ประดิษฐ์มนูญธรรม (PT)',
          desc: '📍ประดิษฐ์มนูญธรรม (PT)📍',
          value: 'ประดิษฐ์มนูญธรรม (PT)',
          addressName:
            'QJV6+27F ปั๊มน้ำมัน PT ประดิษฐมนูธรรม แขวง สะพานสอง เขตวังทองหลาง กรุงเทพมหานคร 10310',
          location: [
            {
              lat_long: '13.792560628471398, 100.61066882025472',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop13',
          timePeriod: '12:00 - 16:00'
        },
        {
          text: 'ประดิษฐ์มนูญธรรม (ES-ND)',
          desc: '📍ประดิษฐ์มนูญธรรม (ES-ND)📍',
          value: 'ประดิษฐ์มนูญธรรม (ES-ND)',
          addressName:
            'Esso Nida Petroleum (Pradit Manuthamj) 361 ซอย ประดิษฐ์มนูญธรรม แขวงลาดพร้าว เขตลาดพร้าว กรุงเทพมหานคร 10230',
          location: [
            {
              lat_long: '13.821287960180761, 100.62541106627015',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop14',
          timePeriod: '14:00 - 18:00'
        },
        // {
        //   text: 'รามอินทรา (PTT-สน)',
        //   desc: '📍รามอินทรา (PTT-สน)📍',
        //   value: 'รามอินทรา (PTT-สน)',
        //   addressName:
        //     '27, ปั๊มน้ำมัน ปตท. สาขา รามอินทรา กม.6.5 1 ถ. รามอินทรา แขวง รามอินทรา เขตคันนายาว กรุงเทพมหานคร 10230',
        //   location: [
        //     {
        //       lat_long: '13.847092615988172, 100.64731867852707',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop15',
        //   timePeriod: '14:00 - 18:00'
        // },
        {
          text: 'รามอินทรา (PTT-กท)',
          desc: '📍รามอินทรา (PTT-กท)📍',
          value: 'รามอินทรา (PTT-กท)',
          addressName:
            'ปั๊มน้ำมัน ปตท. สาขา กรุงเทพ-รามอินทรา 2 340 ถนน ประดิษฐ์มนูธรรม แขวง ท่าแร้ง เขตบางเขน กรุงเทพมหานคร 10220',
          location: [
            {
              lat_long: '13.845379171116159, 100.63645474826342',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop16',
          timePeriod: '14:00 - 18:00'
        },
        // {
        //   text: 'หลักสี่ (PTT)',
        //   desc: '📍หลักสี่ (PTT)📍',
        //   value: 'หลักสี่ (PTT)',
        //   addressName:
        //     'ปั๊ม ปตท. The Deal 99/115-120 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210',
        //   location: [
        //     {
        //       lat_long: '13.889100579376729, 100.5728753568575',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop17',
        //   timePeriod: '14:00 - 18:00'
        // },
        {
          text: 'หลักสี่ (SHLL)',
          desc: '📍หลักสี่ (SHLL)📍',
          value: 'หลักสี่ (SHLL)',
          addressName:
            'Shell, 200/1 ถ. แจ้งวัฒนะ แขวง ทุ่งสองห้อง เขต หลักสี่ กรุงเทพมหานคร 10210',
          location: [
            {
              // lat_long: '13.89205596903052, 100.56229360999114',
              lat_long: '13.8916615, 100.5611644',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop18',
          timePeriod: '14:00 - 18:00'
        },
        {
          text: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
          desc: '📍งามวงศ์วาน-พงษ์เพชร (LTGF)📍',
          value: 'งามวงศ์วาน-พงษ์เพชร (LTGF)',
          addressName:
            'โลตัส พงษ์เพชร 99/9 หมู่ที่ 3 ถนน งามวงศ์วาน ตำบลบางเขน อำเภอเมืองนนทบุรี นนทบุรี 11000',
          location: [
            {
              lat_long: '13.8548247392373, 100.54418646793977',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop19',
          timePeriod: '14:00 - 18:00'
        },
        {
          text: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
          desc: '📍รัตนาธิเบศร์-ไทรม้า (บจ108)📍',
          value: 'รัตนาธิเบศร์-ไทรม้า (บจ108)',
          addressName:
            '79 ปั้มน้ำมันบางจาก - รัตนาธิเบศร์ 11-12 ซอย หมู่ 3 ตำบล บางรักน้อย อำเภอเมืองนนทบุรี นนทบุรี 11000',
          location: [
            {
              lat_long: '13.874392048491998, 100.45798703509423',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop20',
          timePeriod: '14:00 - 18:00'
        },
        {
          text: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
          desc: '📍รัตนาธิเบศร์-บางรักใหญ่ (JF)📍',
          value: 'รัตนาธิเบศร์-บางรักใหญ่ (JF)',
          addressName:
            'ปตท.จิฟฟี่ นนทบุรี-รัตนาธิเบศร์ 2 ถนน บางบัวทอง - สุพรรณบุรี ตำบล บางรักใหญ่ อำเภอบางบัวทอง นนทบุรี 11110',
          location: [
            {
              lat_long: '13.875831600000069, 100.4403315825482',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop21',
          timePeriod: '14:00 - 18:00'
        },
        {
          text: 'ราชพฤกษ์ (TH-W)',
          desc: '📍ราชพฤกษ์ (TH-W)📍',
          value: 'ราชพฤกษ์ (TH-W)',
          addressName:
            'เดอะวอล์ค ราชพฤกษ์ 189 หมู่ที่ 2 ถนน ราชพฤกษ์ ตำบล บางขุนกอง อำเภอบางกรวย นนทบุรี 11130',
          location: [
            {
              lat_long: '13.821225776710818, 100.44972888084453',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop22',
          timePeriod: '14:00 - 18:00'
        },
        {
          text: 'พันท้าย-พระราม2',
          desc: '📍พันท้าย-พระราม2📍',
          value: 'พันท้าย-พระราม2',
          addressName:
            'บ้านเดอะแกรนด์ 98/10 ซ.6 เลค ตำบล พันท้ายนรสิงห์ อำเภอเมืองสมุทรสาคร สมุทรสาคร 74000',
          location: [
            {
              lat_long: '13.5931566, 100.3682269',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop23',
          timePeriod: '09:30 - 15:00'
        },
        // {
        //   text: 'พระราม 2 (CTX พระราม2 แสมดำ)',
        //   desc: '📍พระราม 2 (CTX พระราม2 แสมดำ)📍',
        //   value: 'พระราม 2 (CTX พระราม2 แสมดำ)',
        //   location: [
        //     {
        //       lat_long: '13.64608090445843, 100.41479997140699',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop24',
        //   timePeriod: '10:00 - 15:00',
        //   addressName:
        //     'ปั้มน้ำมันคาเท็กซ์ สาขา พระราม2  แสมดำ 9 111 ซอย พระรามที่ 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
        // },
        // {
        //   text: 'พระราม 2 (PTT พระราม2 กม.7)',
        //   desc: '📍พระราม 2 (PTT พระราม2 กม.7)📍',
        //   value: 'พระราม 2 (PTT พระราม2 กม.7)',
        //   location: [
        //     {
        //       lat_long: '13.653654824300476, 100.42480662395745',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop25',
        //   timePeriod: '10:00 - 15:00',
        //   addressName:
        //     'ปตท. สาขา กรุงเทพฯ-พระราม 2 กม.7   744 ม.6 ถ. พระราม 2 แขวง แสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
        // },
        // {
        //   text: 'ดอนเมือง (PTTสรงประภา)',
        //   desc: '📍ดอนเมือง (PTTสรงประภา)📍',
        //   value: 'ดอนเมือง (PTTสรงประภา)',
        //   location: [
        //     {
        //       lat_long: '13.927687464799938, 100.58518389346402',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop26',
        //   timePeriod: '14:00 - 18:00',
        //   addressName:
        //     'ปตท.สรงประภา ดอนเมือง  , 372 ถนน สรงประภา แขวง สีกัน เขตดอนเมือง กรุงเทพมหานคร 10210'
        // },

        {
          text: 'Nvbb บริษัท',
          desc: '📍Nvbb บริษัท📍',
          value: 'Nvbb บริษัท',
          location: [
            {
              lat_long: '13.6096892, 100.2560354',
              id: '2024-01-30T03:34:06.055Z'
            }
          ],
          shopCharg: 0,
          filterName: 'drop27',
          timePeriod: '09:00 - 16:00',
          addressName:
            'บริษัท เนเวอร์ บีน เบทเธอร์ จำกัด 21 8, ตำบล ท่าเสา อำเภอกระทุ่มแบน สมุทรสาคร 74110'
        },
        {
          text: 'มหาชัย (CT)',
          desc: '📍มหาชัย (CT)📍',
          value: 'มหาชัย (CT)',
          location: [
            {
              lat_long: '13.5719282557341, 100.28893798465869',
              id: '2024-01-30T03:34:06.055Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop28',
          timePeriod: '10:00 - 15:00',
          addressName:
            'เซ็นทรัล มหาชัย 98 ถ. พระราม 2 ตำบล นาดี อำเภอเมืองสมุทรสาคร สมุทรสาคร 74000'
        },
        {
          text: 'พระราม 2 (PT ขาเข้า กม.5)',
          desc: '📍พระราม 2 (PT ขาเข้า กม.5)📍',
          value: 'พระราม 2 (PT ขาเข้า กม.5)',
          location: [
            {
              lat_long: '13.6653207, 100.4430738',
              id: '2021-08-30T05:38:54.613Z'
            }
          ],
          shopCharg: 60,
          filterName: 'drop29',
          timePeriod: '10:00 - 15:00',
          addressName:
            'ปั๊มน้ำมันพีที สาขาพระราม 2 ขาเข้า กม.5, 122 4 ถ. พระรามที่ 2 แขวงแสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150',
          displayString:
            'ปั๊มน้ำมันพีที สาขาพระราม 2 ขาเข้า กม.5, 122 4 ถ. พระรามที่ 2 แขวงแสมดำ เขตบางขุนเทียน กรุงเทพมหานคร 10150'
        }
        // {
        //   text: 'กาญจนาภิเษก (PT บางบอน3)',
        //   desc: '📍กาญจนาภิเษก (PT บางบอน3)📍',
        //   value: 'กาญจนาภิเษก (PT บางบอน3)',
        //   location: [
        //     {
        //       lat_long: '13.6702207, 100.4054731',
        //       id: '2021-08-30T05:38:54.613Z'
        //     }
        //   ],
        //   shopCharg: 60,
        //   filterName: 'drop30',
        //   timePeriod: '00:00 - 24:00',
        //   addressName:
        //     'ปั๊มน้ำมันพีที บางบอน3 (กาแฟพันธุ์ไทย, Max Mart), 95/1 ถ. กาญจนาภิเษก บางบอนเหนือ เขตบางบอน กรุงเทพมหานคร 10150',
        //   displayString:
        //     'ปั๊มน้ำมันพีที บางบอน3 (กาแฟพันธุ์ไทย, Max Mart), 95/1 ถ. กาญจนาภิเษก บางบอนเหนือ เขตบางบอน กรุงเทพมหานคร 10150'
        // }
      ],
      droppointLocationOptions_2: [
        {
          text: 'DROP 1 สาทรเหนือ ใกล้ Q-HOUSE',
          desc: `📍สาทรเหนือ ใกล้ Q-HOUSE📍`,
          value: 'สาทรเหนือ ใกล้ Q-HOUSE',
          link: 'https://goo.gl/maps/eH1AzZjwnjbFsij76'
        },
        // {
        //   text: 'DROP 2 ใกล้ K-Village / Bambini Villa',
        //   desc: `📍ใกล้ K-Village / Bambini Villa📍`,
        //   value: 'ใกล้ K-Village / Bambini Villa',
        //   link: 'https://g.page/Bambinivilla?share'
        // },
        {
          text: 'DROP 3 ใกล้ Central EastVille',
          desc: `📍ใกล้ Central EastVille📍`,
          value: 'ใกล้ Central EastVille',
          link: 'https://goo.gl/maps/vXkiox2Vw9Qkav1Y9'
        },
        {
          text: 'DROP 4 Esso Nida ประดิษมณูญธรรม',
          desc: `📍Esso Nida ประดิษมณูญธรรม📍`,
          value: 'Esso Nida ประดิษมณูญธรรม',
          link: 'https://goo.gl/maps/kiuXqcZ3V5KHuKn38'
        },
        {
          text: 'DROP 5 ใกล้ The Mall งามวงศ์วาน',
          desc: `📍ใกล้ The Mall งามวงศ์วาน📍`,
          value: 'ใกล้ The Mall งามวงศ์วาน',
          link: 'https://goo.gl/maps/645PHxjsPPr36hvAA'
        },
        {
          text: 'DROP 6 เส้นรัตนาธิเบศร์',
          desc: `📍เส้นรัตนาธิเบศร์📍`,
          value: 'เส้นรัตนาธิเบศร์'
        },
        {
          text: 'DROP 7 เส้นราชพฤกษ์',
          desc: `📍เส้นราชพฤกษ์📍`,
          value: 'เส้นราชพฤกษ์'
        },
        {
          text: 'DROP 8 โซนพุทธมณฑล',
          desc: `📍โซนพุทธมณฑล📍`,
          value: 'โซนพุทธมณฑล'
        },
        {
          text: 'DROP 9 เส้นกัลปพฤกษ์',
          desc: `📍เส้นกัลปพฤกษ์📍`,
          value: 'เส้นกัลปพฤกษ์'
        },
        {
          text: 'DROP 10 เส้นพระรามสอง',
          desc: `📍เส้นพระรามสอง📍`,
          value: 'เส้นพระรามสอง'
        },
        {
          text: 'DROP 11 เส้นบางบอน',
          desc: `📍เส้นบางบอน📍`,
          value: 'เส้นบางบอน'
        },
        {
          text: 'DROP 12 สมุทรสาคร',
          desc: `📍สมุทรสาคร📍`,
          value: 'สมุทรสาคร'
        },
        {
          text: 'DROP 13 พระโขนง-สุขุมวิท99',
          desc: '📍พระโขนง-สุขุมวิท99📍',
          value: 'พระโขนง-สุขุมวิท99'
        },
        {
          text: 'DROP 14 โซนหลักสี่-ดอนเมือง',
          desc: '📍โซนหลักสี่-ดอนเมือง📍',
          value: 'โซนหลักสี่-ดอนเมือง'
        },
        {
          text: 'DROP 15 เส้นถ.กาญจนาภิเษก-ตลิ่งชัน',
          desc: '📍เส้นถ.กาญจนาภิเษก-ตลิ่งชัน📍',
          value: 'เส้นถ.กาญจนาภิเษก-ตลิ่งชัน'
        }
      ],
      remark: '',
      remarkToDriver: '',
      quotaDetail: null,
      useSameAddress: false,
      currentZoomImage: null,
      showZoomImage: false,
      destination: ''
    }
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('loadPageProfile', { pagename: this.pagename })

    // var beginningTime = moment()
    // var endTime = moment('6:00pm', 'h:mma')

    // this.mindate = beginningTime.isBefore(endTime)
    //   ? moment().add('2', 'days').format('YYYY-MM-DD')
    //   : moment().add('3', 'days').format('YYYY-MM-DD')
    try {
      if (this.$route.query.destination) {
        this.destination = this.$route.query.destination
      }

      // if (this.$route.query.nvbbshippingtype) {
      //   this.shippingType = this.$route.query.nvbbshippingtype;
      // }

      if (this.$route.query.userid) {
        this.userid = this.$route.query.userid
      } else {
        throw new Error('Not found user')
      }

      this.onChangeOpenMap()

      if (this.pageProfile) {
        if (
          !['102459484852582', '102438735480946'].includes(
            this.pageProfile.pageid
          )
        ) {
          throw new Error('Not found page')
        }
        document.title = this.pageProfile.pagename
          ? this.pageProfile.pagename
          : ''
        this.$store.dispatch('updateShopColor', this.pageProfile.shopcolor)

        await this.getCategories()
        await this.getProducts()
        await this.getnvbbcheckquota()

        try {
          var userdata = await this.getUserDetail()
          this.quotaDetail = await this.getUserQuotaDetail()
          var info = {
            name: null,
            phone: null,
            address: null
          }
          if (userdata) {
            info.name = userdata.name
            info.address = userdata.address
            info.phone = userdata.phone
          }

          var hublocation = this.hubLocationOptions.find((el) => {
            return userdata.remark.includes(el.value)
          })

          if (hublocation) {
            this.hubLocation = hublocation.value
          }

          this.customerName = info.name
          this.customerPhone = info.phone
          if (this.userid) {
            this.getNvbbLastOrderJson()
          }
          this.shippingAddress = info.address

          const getPostCode = () => {
            const address = info.address ? info.address.trim() : ''
            try {
              let postcode = ''
              postcode = address.match(/[ ][1-9]{1}[0-9]{4}$/)
              if (postcode.length > 0) {
                return postcode[0].trim()
              } else {
                return ''
              }
            } catch (error) {
              return ''
            }
          }

          this.postcode = getPostCode()
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error)
        }

        this.loading = false
      } else {
        throw new Error('Not found page')
      }
    } catch (error) {
      if (error.message == 'Not enough shipping quota') {
        await this.$swal({
          title: this.$t('รอบจัดส่งไม่เพียงพอ'),
          text: 'กรุณาชำระรอบจัดส่งเพิ่ม',
          type: 'info',

          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      } else if (error.message == 'Not enough bottle') {
        await this.$swal({
          title: this.$t('จำนวนโควต้าไม่เพียงพอ'),
          text: 'กรุณาชำระรอบจัดส่งเพิ่ม',
          type: 'info',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      } else {
        Sentry.captureException(error)
      }
    }
  },
  methods: {
    async changeDroppoint() {
      const vm = this
      const drop = vm.droppointLocationOptions.find((el) => {
        return el.text == vm.droppointLocationOptions_1Select
      })
      vm.loadingLalamove = true
      vm.loadingMapInfo = true
      vm.onMapLoading = true
      // eslint-disable-next-line no-undef
      let start = null
      let end = []

      start = new google.maps.LatLng(
        vm.lalamove.result.data.stops[1].coordinates.lat,
        vm.lalamove.result.data.stops[1].coordinates.lng
      )

      end = [drop]
        .map((el) => {
          try {
            if (el.location) {
              const lat_lng = el.location[0].lat_long.split(', ')
              if (lat_lng.length > 1)
                // eslint-disable-next-line no-undef
                return {
                  shop: el,
                  location: {
                    lat: parseFloat(lat_lng[0]),
                    lng: parseFloat(lat_lng[1])
                  }
                }
            }
          } catch (error) {
            //
          }
          return false
        })
        .filter((el) => el != false)
      vm.findShortestRoute(start, end)
    },
    async getNvbbLastOrderJson() {
      const vm = this
      const response = await axios.get(
        `${config.getConfig('serverUrl')}nvbb_last_order_json?pageid=${
          vm.pageProfile.pageid
        }&userid=${vm.userid}`
      )
      if (response.status && response.data.success && response.data.result) {
        const order_json = JSON.parse(response.data.result.order_json)
        if (order_json) {
          vm.hubLocationDroppoint = vm.droppointLocationOptions.find((el) => {
            return el.filterName == order_json.filterName
          })

          order_json.data.stops[0].address = vm.hubLocationDroppoint.addressName
          vm.placesinfolabel = order_json.data.stops[1].address
          if (order_json.remarks && order_json.remarks.value) {
            vm.remarkToDriver = order_json.remarks.value
          }
          vm.$set(vm.gmapvalue, 'lat', order_json.data.stops[1].coordinates.lat)
          vm.$set(vm.gmapvalue, 'lng', order_json.data.stops[1].coordinates.lng)

          vm.shippingType = 'drop'
          vm.gmapLocation(true)
        }
      }
    },
    onChangeOpenMap() {
      if (
        !['102459484852582', '102438735480946'].includes(
          this.pageProfile.pageid
        )
      )
        return false
      // this.loadingLalamove = true;
      this.loadingMapInfo = true
      this.onMapLoading = true
      // var hublocation = this.droppointLocationOptions.find((el) => {
      //   return el.value == name;
      // });
      // this.shopName = name;
      this.droppointLocationOptions.map((hublocation) => {
        this.shoplocation.push({
          name: hublocation,
          id: hublocation.location[0].id,
          lat_long: hublocation.location[0].lat_long
        })
      })
      // this.shoplocation = [
      //   {
      //     name: hublocation,
      //     id: hublocation.location[0].id,
      //     lat_long: hublocation.location[0].lat_long,
      //   },
      // ];
      this.getbranchlocation()
    },
    getFixUserCharge(lalamove_fee, shop_fee) {
      let data = Nvbb.checkPrice(this.userid)
      if (data) {
        if (data.type == 'add') {
          return {
            total: lalamove_fee + data.charge,
            shop_fee: data.charge,
            lalamove_fee: lalamove_fee
          }
        } else if (data.type == 'fix') {
          return {
            total: data.charge,
            shop_fee: 0,
            lalamove_fee: data.charge
          }
        }
      } else {
        return {
          total: lalamove_fee + shop_fee,
          shop_fee: shop_fee,
          lalamove_fee: lalamove_fee
        }
      }
    },
    onMapReady() {
      // Ready
      this.loadingMap = false
    },
    onMapLoading(val) {
      this.loadingMapInfo = val
    },
    gmapLocation(submitDailog) {
      try {
        var vm = this
        vm.loadingLalamove = true
        vm.loadingMapInfo = true
        vm.onMapLoading = true
        // eslint-disable-next-line no-undef
        let start = new google.maps.LatLng(
            this.gmapvalue.lat.toString(),
            this.gmapvalue.lng.toString()
          ),
          end = []
        end = this.droppointLocationOptions
          .map((el) => {
            try {
              if (el.location) {
                let lat_lng = el.location[0].lat_long.split(', ')
                if (lat_lng.length > 1)
                  // eslint-disable-next-line no-undef
                  return {
                    shop: el,
                    location: {
                      lat: parseFloat(lat_lng[0]),
                      lng: parseFloat(lat_lng[1])
                    }
                  }
              }
            } catch (error) {
              vm.loadingLalamove = false
              return false
              //
            }
            return false
          })
          .filter((el) => el != false)
        if (submitDailog) {
          this.findShortestRoute(start, end)
        } else {
          // eslint-disable-next-line no-undef
          var service = new google.maps.DistanceMatrixService()
          var origins = [start]

          service.getDistanceMatrix(
            {
              origins,
              destinations: [start],
              travelMode: 'DRIVING',
              region: 'TH'
            },
            callback
          )
          // eslint-disable-next-line no-inner-declarations
          function callback(response, status) {
            if (status == 'OK') {
              if (!vm.placesinfolabel) {
                vm.placesinfolabel = response.destinationAddresses[0]
              }
              // vm.shippingAddressSet = vm.placesinfolabel;
            }
          }
        }
      } catch (error) {
        vm.loadingLalamove = false
        return false
      }
    },

    PythagorasEquirectangular(lat1, lon1, lat2, lon2) {
      var R = 6371 // Radius of the earth in km
      var dLat = this.Deg2Rad(lat2 - lat1) // this.Deg2Rad below
      var dLon = this.Deg2Rad(lon2 - lon1)
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.Deg2Rad(lat1)) *
          Math.cos(this.Deg2Rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      var d = R * c // Distance in km
      return d
    },
    Deg2Rad(deg) {
      return (deg * Math.PI) / 180
    },

    async getDistance(start, end) {
      try {
        // eslint-disable-next-line no-undef
        let service = new google.maps.DirectionsService()
        return new Promise((resolve, reject) => {
          service.route(
            {
              origin: start,
              destination: end.location,
              travelMode: 'DRIVING',
              region: 'TH',
              drivingOptions: {
                departureTime: new Date(),
                trafficModel: 'optimistic'
              }
            },
            (response, status) => {
              if (status == 'OK') {
                resolve({ shop: end.shop, response })
              } else {
                reject(false)
              }
            }
          )
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
    },

    NearestCity(latitude, longitude, branches) {
      var minDif = 99999
      // var closest;

      for (var index = 0; index < branches.length; ++index) {
        var dif = this.PythagorasEquirectangular(
          parseFloat(latitude),
          parseFloat(longitude),
          parseFloat(branches[index].location.lat),
          parseFloat(branches[index].location.lng)
        )
        if (dif < minDif) {
          // closest = index;
          minDif = dif
        }
        branches[index].location.dif = dif
      }

      branches.sort((a, b) => {
        var x = parseFloat(a.location.dif)
        var y = parseFloat(b.location.dif)
        return x - y
      })
      if (branches.length - 8 > 0) {
        var nearest_branch = branches.splice(0, 8)
        return nearest_branch
      } else {
        return branches
      }
    },

    async findShortestRoute(start, end) {
      this.loadingMapInfo = true
      var nearest_branch = this.NearestCity(start.lat(), start.lng(), end)
      let getDistancePromise = nearest_branch.map((el) => {
        return this.getDistance(start, el)
      })

      if (getDistancePromise.length == 0) {
        return
      }
      let getDistanceResponses = await Promise.all(getDistancePromise)
      getDistanceResponses = getDistanceResponses.filter((el) => el != false)
      let nearest = getDistanceResponses[0]
      try {
        let leg = nearest.response.routes[0].legs[0]

        this.hubLocationDroppoint = nearest.shop
        let nearestlocation = {
          name: nearest.shop.text,
          distance: parseFloat((leg.distance.value / 1000).toFixed(2)),
          pictureurl: null,
          id: nearest.id,
          lat_long: leg.end_location.lat() + ',' + leg.end_location.lng()
        }
        const placesinfolabel = this.placesinfolabel
          ? this.placesinfolabel.replace(/(<([^>]+)>)/gi, '')
          : ''

        this.shippingAddress = `${
          this.shippingAddressSet &&
          this.shippingAddressSet !== '' &&
          `(${this.shippingAddressSet})`
        } ${placesinfolabel}`

        nearestlocation.originAddresses = leg.start_address
        nearestlocation.originLatLng = leg.start_location
        nearestlocation.destinationAddresses =
          this.hubLocationDroppoint.addressName
        nearestlocation.destinationLatLng = leg.end_location
        nearestlocation.shop_detail = nearest.shop
        nearestlocation.id = nearest.id
        try {
          this.placesinfolabel = await this.setPlacesInfoLabel(nearestlocation)
          var drop = this.droppointLocationOptions.find((el) => {
            return el.text == this.hubLocationDroppoint.text
          })
          this.droppointLocationOptions_1Select = drop.text
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error)
          //
        } finally {
          this.loadingMapInfo = false
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        this.loadingMapInfo = false
      }
    },
    handleClearPlaceLabel() {
      this.shippingAddress = ''
      this.gmapvalue = {}
      this.placesinfolabel = null
      this.lastordercoords = null
    },
    async setPlacesInfoLabel(shop) {
      const vm = this
      if (shop) {
        vm.notShipping = false
        // - ซื้อครบ 1,000 ส่งฟรี
        // - ยอดสั่งซื้อขั้นต่ำ 200 บาท
        if (vm.shippingType == 'drop') {
          const shop_lat_long =
            shop.originLatLng && typeof shop.originLatLng == String
              ? shop.originLatLng.split(',')
              : [shop.originLatLng.lat(), shop.originLatLng.lng()]
          const customer_lat_long =
            shop.shop_detail.location[0].lat_long.split(', ')

          let customer_phone = vm.customerPhone || '00'

          if (customer_phone.charAt(0) == '0') {
            customer_phone = customer_phone.slice(1)
            customer_phone = '+66' + customer_phone
          }
          const request = {
            serviceType: 'MOTORCYCLE', // fix
            specialRequests: ['LALABAG'],
            stops: [
              {
                location: {
                  lat: customer_lat_long[0].toString(), // lat ร้านค้า
                  lng: customer_lat_long[1].toString() // lng ร้านค้า
                },
                addresses: {
                  th_TH: {
                    displayString: shop.destinationAddresses,
                    market: 'TH_BKK' // fix
                  }
                }
              },
              {
                location: {
                  lat: shop_lat_long[0].toString(), // lat ลูกค้า
                  lng: shop_lat_long[1].toString() // lng ลูกค้า
                },
                addresses: {
                  th_TH: {
                    displayString: vm.shippingAddress,
                    market: 'TH_BKK' // fix
                  }
                }
              }
            ],
            requesterContact: {
              name: 'คุณสายชล (รถโตโยต้า สีขาว 5950)',
              phone: '+66628844598'
            },
            deliveries: [
              {
                toStop: 1, // fix
                toContact: {
                  name: vm.customerName || 'null',
                  phone: customer_phone
                },
                remarks: vm.remarkToDriver // ข้อความถึงคนขับ
              }
            ]
          }

          const requestV3 = {
            data: {
              serviceType: 'MOTORCYCLE',
              specialRequests: ['FOOD_DELIVERY'],
              language: 'th_TH',
              stops: [
                {
                  coordinates: {
                    lat: customer_lat_long[0].toString(), // lat ร้านค้า
                    lng: customer_lat_long[1].toString() // lng ร้านค้า
                  },
                  address: shop.destinationAddresses
                },
                {
                  coordinates: {
                    lat: shop_lat_long[0].toString(), // lat ลูกค้า
                    lng: shop_lat_long[1].toString() // lng ลูกค้า
                  },
                  address: vm.shippingAddress
                }
              ]
            }
          }
          // eslint-disable-next-line no-undef

          let result = null

          vm.lalamove.result = _.cloneDeep(requestV3)
          result = await vm.calculateShippingPriceFromLalamove2(requestV3)

          vm.lalamove.shop_fee ? parseInt(shop.shop_detail.shopCharg) : 0

          if (result && result.price) {
            let { total, shop_fee, lalamove_fee } = vm.getFixUserCharge(
              parseInt(result.price),
              vm.hubLocationDroppoint.shopCharg
            )

            vm.lalamove.fee = lalamove_fee
            vm.lalamove.shop_fee = shop_fee
            vm.totalPrice = total
            vm.notShipping = result.notShipping
          }
          if (!result) {
            this.totalPrice = null
          }
        }

        if (config.env == 'shop') vm.checkShippingPrice()
        vm.loadingLalamove = false
        vm.loadingMapInfo = false
        vm.onMapLoading = false
        return vm.placesinfolabel
      }
    },
    async calculateShippingPriceFromLalamove2(data) {
      let price = 0,
        notShipping = true
      try {
        let response = await axios.post(
          `${config.getConfig('serverUrl')}lalamove/v3/${
            this.pageProfile.pageid
          }/get-quotation`,
          data
        )
        if (response.status && response.data.success && response.data.result) {
          const res = response.data.result.data
          price = res.priceBreakdown.total
          notShipping = false
        } else {
          price = null
        }
      } catch (error) {
        //
        console.error(error)
        this.handleClearPlaceLabel()
        if (
          error.response.data.message == 'FAILED_GET_LALAMOVE_QUOTATION_V3' &&
          error.response.data.result
        ) {
          const errors = error.response.data.result.errors
          if (errors && errors.length > 0) {
            this.hubLocationDroppoint = null

            if (errors[0].id == 'ERR_OUT_OF_SERVICE_AREA') {
              await this.$swal({
                title: this.$t('Error'),
                text: 'เนื่องจากสถานที่นี้อยู่นอกการจัดส่ง กรุณาลองใหม่อีกครั้ง',
                type: 'error',
                confirmButtonText: this.$t('Confirm'),
                cancelButtonText: this.$t('Cancel'),
                reverseButtons: true
              })
            } else {
              await this.$swal({
                title: this.$t('Error'),
                text: errors[0].message,
                type: 'error',
                confirmButtonText: this.$t('Confirm'),
                cancelButtonText: this.$t('Cancel'),
                reverseButtons: true
              })
            }
          }
        }

        return false
      }

      return { price, notShipping }
    },
    async calculateShippingPriceFromLalamove(data) {
      const vm = this
      const price = 0,
        notShipping = true
      try {
        const response = await axios.post(
          `${config.getConfig('serverUrl')}lalamove/${
            vm.pageProfile.pageid
          }/get-quotation`,
          data
        )
        if (response.status && response.data.success && response.data.result) {
          price = response.data.result.totalFee
          notShipping = false
        } else {
          price = null
        }
      } catch (error) {
        console.error(error)
      }

      return { price, notShipping }
    },
    getbranchlocation() {
      var vm = this
      if (!this.externalScript) {
        vm.showmap = false
        this.externalScript = document.createElement('script')
        this.externalScript.setAttribute(
          'src',
          `https://maps.googleapis.com/maps/api/js?key=${vm.googleapikey}&language=th&libraries=places`
        )
        this.externalScript.async = true
        this.externalScript.defer = true
        this.externalScript.onload = () => {
          vm.showmap = true
        }
        document.head.appendChild(this.externalScript)
      }
    },
    changeBottle() {
      this.summaryBottle()
    },
    summaryBottle() {
      var total = this.getTotalBottle()

      // eslint-disable-next-line no-undef
      this.totalBottle = _.cloneDeep(total)
      this.grandTotalBottle = this.producttype
        .map((el) => {
          if (total[el] !== undefined) {
            return total[el].large + total[el].small
          } else return null
        })
        .filter((el) => {
          return el != null
        })
        .reduce((prev, curr) => {
          return prev + curr
        }, 0)
    },
    getTotalBottle() {
      // return {small: 0, large: 0};
      var bottles = {}
      this.producttype.forEach((el) => {
        bottles[el] = { small: 0, large: 0 }
      })

      return this.productlist
        .map((el) => {
          let type
          if (el.name.includes('ชอท')) {
            type = 'phytoshot'
          } else {
            type = el.type
          }
          return { name: el.name, type: type, bottle: el.bottle }
        })
        .reduce(
          (prev, cur) => {
            try {
              var type = cur.type.toLowerCase()

              if (prev[type] === undefined) {
                // eslint-disable-next-line no-undef
                prev[type] = _.cloneDeep(cur.bottle)
              } else {
                prev[type].small = prev[type].small + cur.bottle.small
                prev[type].large = prev[type].large + cur.bottle.large
              }
            } catch (error) {
              Sentry.captureException(error)
            }
            return prev
          },
          { ...bottles }
        )
    },
    zoomImage(image) {
      if (image) {
        this.currentZoomImage = image
        this.showZoomImage = true
      }
    },
    changeInfo() {
      this.useSameAddress = false
    },
    switchUserAddress(value) {
      // eslint-disable-next-line no-console
      if (value && this.quotaDetail) {
        this.cached_info = {
          name: this.customerName,
          address: this.shippingAddress,
          phone: this.customerPhone
        }
        this.customerName = this.quotaDetail.name
        this.shippingAddress = this.quotaDetail.address
        this.customerPhone = this.quotaDetail.phone
      } else if (this.cached_info) {
        this.customerName = this.cached_info.name
        this.shippingAddress = this.cached_info.address
        this.customerPhone = this.cached_info.phone
      }
    },
    getUserQuotaDetail: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress?pageid=' +
              vm.pageProfile.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data)
              } else {
                reject()
              }
            } else {
              reject()
            }
          })
      })
    },
    getUserDetail: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress2?pageid=' +
              vm.pageProfile.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data)
              } else {
                resolve(null)
              }
            } else {
              reject()
            }
          })
      })
    },
    goTo(scrollTo) {
      return goTo(scrollTo)
    },
    async getnvbbcheckquota() {
      var request = {
        pageid: this.pageProfile.pageid,
        userid: this.userid
      }
      var response = await axios.get(
        config.getConfig('serverUrl') + 'nvbbcheckquota',
        {
          params: request,
          headers: { AUTHORIZATION: 'Bearer xxx xxx' }
        }
      )
      if (response.status == 200 && response.data.responsecode == 200) {
        this.bottle = response.data.quota.product_qouta
        // var totalbottle = this.producttype
        //   .map((el) => {
        //     if (this.bottle[el])
        //       return parseInt(this.bottle[el].bigbottles) + parseInt(this.bottle[el].smallbottles);
        //     else return null;
        //   })
        //   .filter((el) => {
        //     return el != null;
        //   })
        //   .reduce((prev, curr) => {
        //     return prev + curr;
        //   }, 0);

        if (response.data.quota.other_products)
          this.other_products = response.data.quota.other_products

        this.summaryBottle()
        this.shippingQuota.hub = 99999 //response.data.quota.hub
        this.shippingQuota.interexpress = response.data.quota.interexpress
        this.shippingQuota.scg = response.data.quota.scg

        // if (totalbottle == 0) {
        //   throw new Error("Not enough bottle");
        // }

        // if (this.shippingQuota[this.shippingType] == 0) {
        //   // throw new Error("Not enough shipping quota");
        //   var result = await this.$swal({
        //     title: this.$t("รอบจัดส่งไม่เพียงพอ"),
        //     text: "กรุณาชำระรอบจัดส่งเพิ่ม",
        //     type: "info",
        //     showCancelButton: true,
        //     confirmButtonText: this.$t("ชำระรอบส่งเพิ่ม"),
        //     cancelButtonText:
        //       this.shippingType == "interexpress"
        //         ? this.$t("25 ขวดขึ้นไปส่งฟรี")
        //         : this.$t("15 ขวดขึ้นไปส่งฟรี"),
        //     reverseButtons: true,
        //   });

        //   if (result.value) {
        //     this.$router.push({
        //       name: "ecommerce",
        //       params: { id: this.pageProfile.pageid },
        //       query: { ...this.$route.query, pid: this.shippingType == "interexpress" ? 391 : 390 },
        //     });
        //     window.location.reload();
        //   }
        // }
      } else {
        //
      }
    },
    allowedDates(val) {
      const holiday = ['2026-04-14', '2026-12-29', '2026-12-31']
      const isHoliday = holiday.some((el) => moment(val).isSame(el))
      if (isHoliday) return false

      const date = moment(val)
      const weekday = date.weekday().toString()
      const today = moment().weekday().toString()

      if (weekday === '2' && today === '0') {
        const twoDaysLater = moment().add(2, 'days')
        return !moment(val).isSame(twoDaysLater, 'day')
      }

      if (this.shippingType == 'express') {
        let postcode = this.postcode
        if (!postcode) {
          try {
            postcode = this.shippingAddress.match(/[1-9]{1}[0-9]{4}/)
            if (postcode.length > 0) {
              postcode = postcode[0].trim()
            } else {
              throw new Error('Many postcode')
            }
          } catch (error) {
            postcode = false
          }
        }

        if (!postcode) {
          return false
        }
        let location = getBangkokLocation(postcode, this.shippingAddress)

        // // อังคาร พุธ พฤ ส
        // if (['BKK', 'MET', 'REM'].includes(location)) {
        //   // return ['2', '3', '4', '6'].includes(moment(val).weekday().toString())
        //   return ['2', '4', '6'].includes(weekday)
        //   //scg
        // } else {
        //   // return ['2', '3', '4', '6'].includes(moment(val).weekday().toString())
        //   // return ['2', '4', '6'].includes(weekday)
        //   return ['2', '4'].includes(weekday)
        //   //interexpress
        // }

        if (['BKK', 'MET'].includes(location)) {
          return ['1', '2', '3', '4', '5', '6'].includes(weekday)
        } else {
          return ['2', '4'].includes(weekday)
        }
      }

      var days = []
      if (
        this.hubLocation === 'โซนพระราม 4 - สุขุมวิท 26' &&
        this.shippingType !== 'drop'
      ) {
        days = ['4', '6']
      } else {
        days = ['2', '4', '6']
      }

      return days.includes(weekday) // other
    },
    onSelectProduct() {},
    getCategories() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageProfile.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'categories', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.categories = []
              var categories = response.categorylist.map(function (category) {
                var c = category
                c.productCount = 0
                return c
              })
              vm.categories = categories
              resolve()
            } else {
              reject()
            }
          })
      })
    },
    getProducts() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageProfile.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}

              var result = vm.formatProducts(
                // eslint-disable-next-line no-undef
                _.cloneDeep(response.productlist),
                vm.categories
              )

              var allresult = vm.formatProducts(
                // eslint-disable-next-line no-undef
                _.cloneDeep(response.productlist)
              )
              vm.products = allresult.product_by_index

              // eslint-disable-next-line no-undef
              vm.productlist = _.cloneDeep(result.products)
              // eslint-disable-next-line no-undef
              vm.allproducts = _.cloneDeep(allresult.products)

              vm.hasSaleCategory = false

              vm.productlist.forEach((val) => {
                if (parseFloat(val.price) > parseFloat(val.discountprice)) {
                  vm.hasSaleCategory = true
                } else {
                  var isDiscount = false
                  if (val.productstock) {
                    var discountIndex = val.productstock.findIndex(function (
                      stock
                    ) {
                      return parseFloat(stock[3]) > parseFloat(stock[4])
                    })
                    isDiscount = discountIndex != -1
                  }
                  vm.hasSaleCategory = !isDiscount
                }
              })
              resolve()
            } else {
              reject()
            }
          })
          .catch(() => {
            reject()
          })
      })
    },
    formatProducts(products, categories) {
      var product_by_index = {}
      var newproducts = products.map((val) => {
        // eslint-disable-next-line no-undef
        let product = _.cloneDeep(val)
        product.price = parseFloat(product.price)
        product.discountprice = parseFloat(product.discountprice)
        product.isOutOfStock = false

        if (categories) {
          var categoryIndex = categories.findIndex(
            (x) => x.id === product.categoryid
          )

          if (categoryIndex != -1) {
            categories[categoryIndex].productCount++
          }
        }
        var type = 'none'

        if (product.productstock && product.productstock.length > 0) {
          var haveStock = false

          product.productstock = product.productstock.map(function (pval) {
            // eslint-disable-next-line no-undef
            var stock = _.cloneDeep(pval)
            try {
              var typeAndName = pval[1].split('-')

              if (typeAndName.length == 2) {
                type = typeAndName[0]
                stock[1] = typeAndName[1]
              }
            } catch (error) {
              // eslint-disable-next-line no-console
              console.log(error)
            }

            if (parseInt(pval[2]) > 0) {
              haveStock = true
            }

            var price = 0
            var discount = 0

            if (pval[3] == null && pval[4] == null) {
              price = parseFloat(val.price)
              discount = parseFloat(val.discountprice)
            } else {
              if (pval[3] == null) {
                price = parseFloat(val.price)
              } else {
                price = parseFloat(pval[3])
              }

              if (pval[4] == null) {
                discount = pval[3]
              } else {
                discount = parseFloat(pval[4])
              }
            }

            stock[3] = price
            stock[4] = discount
            return stock
          })

          if (!haveStock) {
            product.isOutOfStock = true
          }
        } else {
          product.isOutOfStock = true
        }
        if (val) {
          product_by_index[val.id] = val
        }

        product.type = type

        product.bottle = {
          small: 0,
          large: 0
        }

        return product
      })

      return {
        products: newproducts,
        product_by_index: product_by_index
      }
    },
    async onCheckout() {
      this.page = 'checkout'
      await this.$nextTick()
      goTo(0)
    },
    async onProceedShipping() {
      try {
        var vm = this
        var result = await this.$validator.validate()
        if (!result) {
          // do stuff if not valid.
          this.goToErrorInput()
          throw 400
        }
        this.loading = true
        let shippingAddress = ''
        if (['hub', 'hub+msg', 'drop'].includes(this.shippingType)) {
          // shippingAddress = this.hubLocation;
        } else {
          //
        }
        shippingAddress = this.shippingAddress

        if (this.postcode) {
          shippingAddress = shippingAddress + ' ' + this.postcode
        }

        var address =
          this.customerName +
          ' , ' +
          shippingAddress +
          ' , ' +
          this.customerPhone
        var products = this.productlist.filter((el) => {
          return el.bottle.small > 0 || el.bottle.large > 0
        })
        var cart = []
        try {
          products.forEach((el) => {
            if (el.bottle.small > 0) {
              cart.push({
                photourl: el.photourl,
                name: el.name,
                option: (el.type != 'none' ? el.type + '-' : '') + 'ขวดเล็ก',
                quantity: el.bottle.small
              })
            }
            if (el.bottle.large > 0) {
              cart.push({
                photourl: el.photourl,
                name: el.name,
                option: (el.type != 'none' ? el.type + '-' : '') + 'ขวดใหญ่',
                quantity: el.bottle.large
              })
            }
          })
          if (this.other_products) {
            var other_products = this.other_products.map((el) => {
              return {
                photourl: el.imgae_url,
                name: el.name,
                option: el.name,
                quantity: el.qty
              }
            })
            cart = [...cart, ...other_products]
          }
        } catch (error) {
          console.log('error', error)
          //
        }

        var hubAddress = ''
        let hublocation
        if (['hub', 'hub+msg'].includes(this.shippingType)) {
          hublocation = this.hubLocationOptions.find((el) => {
            return el.value == this.hubLocation
          })

          if (hublocation) {
            // hubAddress = `${hublocation.text} \n${hublocation.desc} \n${hublocation.link}`
            hubAddress = hublocation.text
          }

          if (this.shippingType == 'hub+msg') {
            hubAddress = hubAddress + ' (HUB to home)'
          }
        } else if (this.shippingType == 'drop') {
          hublocation = this.droppointLocationOptions.find((el) => {
            return el.value == this.hubLocation
          })
          // if page test
          if (vm.shippingType == 'drop') {
            hublocation = this.hubLocationDroppoint
          }

          if (hublocation) {
            // hubAddress = `${hublocation.text || ''} \n${
            //   hublocation.desc || ''
            // } \n${hublocation.link || ''}`
            hubAddress = hublocation.text
          }
        }

        let shippingType
        if (['hub', 'hub+msg'].includes(this.shippingType)) shippingType = 'hub'
        else if (['express'].includes(this.shippingType)) {
          let postcode = this.postcode
          if (!postcode) {
            try {
              postcode = this.shippingAddress.match(/[1-9]{1}[0-9]{4}/)
              if (postcode.length > 0) {
                postcode = postcode[0].trim()
              } else {
                throw new Error('Many postcode')
              }
            } catch (error) {
              postcode = false
            }
          }

          if (!postcode) return false
          let location = getBangkokLocation(postcode, this.shippingAddress)

          if (['BKK', 'MET'].includes(location)) {
            shippingType = 'scg'
          } else {
            shippingType = 'interexpress'
          }
        } else shippingType = this.shippingType

        if (vm.shippingType == 'drop') {
          // hubAddress = `${hublocation.text ? hublocation.text : ''} ${
          //   hublocation.desc ? hublocation.desc : ''
          // } ${hublocation.link ? hublocation.link : ''}`
          hubAddress = `${hublocation && hublocation.text ? hublocation.text : ''}`
        }
        var request = {
          cart: cart,
          pageid: this.pageProfile.pageid,
          userid: this.userid,
          address: address,
          shippingdate: this.pickupdate
            ? moment(this.pickupdate).format('YYYY-MM-DD')
            : null,
          shippingtype: shippingType,
          phone: this.customerPhone,
          name: this.customerName,
          remark: hubAddress + (this.remark ? '\n' + this.remark : ''),
          // remark:
          //   hubAddress +
          //   (this.remark ? '\n' + this.remark : '') +
          //   '\n' +
          //   (hublocation
          //     ? 'ช่วงเวลาจัดส่งประมาณ ' + hublocation.timePeriod
          //     : ''),
          shippingcharge: this.calculateShippingPrice
        }
        if (vm.shippingType == 'drop') {
          vm.lalamove.result.remarks = vm.remarkToDriver

          try {
            request.order_json = {
              ...vm.lalamove.result,
              totalFee: vm.lalamove.fee, // optional
              totalFeeCurrency: 'THB', // optional
              shop_fee: vm.lalamove.shop_fee,
              filterName: hublocation.filterName,
              specialRequests: ['FOOD_DELIVERY']
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error)
          }
        }

        // if (vm.$route.query.from) {
        //   request.from = vm.$route.query.from

        var response = await axios.post(
          config.getConfig('serverUrl') + 'nvbbbanktransfernotify',
          request,
          {
            headers: { AUTHORIZATION: 'Bearer xxx xxx' }
          }
        )

        response = response.data
        var prefix_message = 'ดำเนินการสั่งสำเร็จ Pre-order no: '
        if (response.responsecode == 200) {
          // if (vm.$liff.isInClient())
          await vm.sendMessage(prefix_message + response.orderid, response)
          let result = await vm.showCompletePopup()
          //เสร็จสิ้น
          // eslint-disable-next-line
          if (vm.$liff.isInClient()) {
            if (result.value) {
              // eslint-disable-next-line no-undef
              vm.$liff.closeWindow()
              window.close()
            } else {
              // แพลนรอบถัดไป
              vm.page = 'products'
            }
          } else {
            if (result.value) {
              try {
                await this.MessengerCloseWindow()
              } catch (error) {
                Sentry.captureException(
                  `[Error] FB Send message -> Pageid: ${
                    vm.pageProfile.pageid
                  }, Order: ${response.orderid} , Userid: ${
                    vm.userid || '-'
                  }, responsecode: ${response.responsecode}`
                )
                window.location.assign(
                  'https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window...'
                )
              } finally {
                window.close()
                window.location.reload()
              }
            } else {
              // แพลนรอบถัดไป
              this.page = 'products'
            }
          }
        } else if (response.responsecode == 400) {
          await this.sendMessage(
            `ทำรายการไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ (${response.responsecode}) ${response.reason}`
          )
          Sentry.captureException(
            `[Error] nvbb proceed order -> Pageid: ${
              this.pageProfile.pageid
            } , Userid: ${this.userid || '-'}, responsecode: ${
              response.responsecode
            }`
          )
          await this.$swal({
            title: this.$t('Error'),
            text: this.$t(response.reason),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        } else if (response.responsecode == 201) {
          await this.sendMessage(prefix_message + response.orderid, response)
          await this.showCompletePopup()
          if (this.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            this.$liff.closeWindow()
            window.close()
          } else {
            try {
              await this.MessengerCloseWindow()
            } catch (error) {
              Sentry.captureException(
                `[Error] FB Send message -> Pageid: ${
                  vm.pageProfile.pageid
                }, Order: ${response.orderid} , Userid: ${
                  vm.userid || '-'
                }, responsecode: ${response.responsecode}`
              )

              window.location.assign(
                'https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window...'
              )
            } finally {
              window.close()
              window.location.reload()
            }
          }

          // let url = "/ecommerce/" + this.pagename;
          // if (this.userid && this.userid != null && this.userid != "") {
          //   url += "?userid=" + this.userid;
          // }
          // this.$router.push({ path: url });
        } else {
          await this.sendMessage(
            `ทำรายการไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ (${response.responsecode})`
          )
          Sentry.captureException(
            `[Error] nvbb proceed order -> Pageid: ${
              this.pageProfile.pageid
            } , Userid: ${this.userid || '-'}, responsecode: ${
              response.responsecode
            }`
          )
          await this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again..'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        }
        this.loading = false
      } catch (error) {
        console.log('errorAll', error)
      }
    },
    MessengerCloseWindow() {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        MessengerExtensions.requestCloseBrowser(
          function success() {
            resolve()
          },
          async function error(error) {
            Sentry.captureException(error)

            reject()
          }
        )
      })
    },
    async sendMessage(message, response = {}) {
      try {
        if (this.$liff.isInClient()) {
          // eslint-disable-next-line no-undef
          return await this.$liff.sendMessages([
            {
              type: 'text',
              text: message
            }
          ])
        } else {
          try {
            await this.sendMessageWithQuota(message)
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error)
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)

        try {
          await this.sendMessageWithQuota(message)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error)
        }

        Sentry.captureException(
          `[Error] Send message -> Pageid: ${this.pageProfile.pageid}, Order: ${
            response.orderid || '-'
          } , Userid: ${this.userid || '-'}, responsecode: ${
            response.responsecode || '-'
          }`
        )
        Sentry.captureException(error)
      }
    },
    async sendMessageWithQuota(message) {
      await axios.post(
        config.getConfig('serverUrl') +
          `line/${this.pageProfile.pageid}/send-message`,
        {
          userid: this.userid,
          sessiontoken: this.$route.query.sessiontoken,
          message: message
        },
        {
          params: {},
          headers: { AUTHORIZATION: 'Bearer xxx xxx' },
          responseType: 'arraybuffer'
        }
      )
    },
    async showCompletePopup() {
      return await this.$swal({
        title: this.$t('Success'),
        text: this.$t('แจ้งรับสินค้าโควต้าเรียบร้อยนะคะ'),
        type: 'success',
        confirmButtonText: 'เสร็จสิ้น',
        cancelButtonText: '<< แพลนรอบถัดไป',
        showCancelButton: true,
        reverseButtons: true
      })
    },
    onWheelZipcode(e) {
      e.preventDefault()

      const inputZipcode = this.$refs.inputZipcode
      if (inputZipcode) {
        inputZipcode.blur()
      }
    }
  }
}
</script>

<style lang="scss">
.v-tabs__item--active {
  background: #eee;
}

.v-tooltip__content {
  font-size: 15px !important;
  opacity: 1 !important;
}

.input-zipcode {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  appearance: textfield;
  -moz-appearance: textfield;
}

.radio-custom {
  padding: 8px 16px;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  cursor: pointer;

  &.active {
    border-color: #1ca085;
    background-color: #1ca0852a;
  }
}

.radio-custom__content {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
}

.radio-custom__title {
  font-size: 20px;
  font-weight: 700;
  color: #1ca085;
}

.radio-custom__header {
  font-size: 14px;
  color: #000;
  text-align: left;
}

.radio-custom__body {
  margin-left: auto;
  font-size: 14px;
  color: #000;
  min-width: 60%;
}

@media screen and (max-width: 600px) {
  .radio-custom__content {
    flex-direction: column;
    gap: 16px;
  }

  .radio-custom__header {
    text-align: center;
  }

  .radio-custom__body {
    width: 100%;
  }
}

.radio-custom > .v-label {
  width: 100%;
}
</style>
